import React, { useEffect, useState, useMemo} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import StandardNavbar from '../components/StandardNavbar';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import ScrollToTop from '../components/ScrollToTop';
import ReservaRedirect from '../components/ReservaRedirect';
import useGTM from '../hooks/useGTM';
import WhatsAppButton from '../components/WhatsAppButton';
import { getDestinoImage, getAllDestinoImages } from '../utils/destinoImageMapper.mjs';
import { 
  MapPin, Calendar, Clock, Users, Plane, Hotel, 
  Utensils, ChevronDown, ChevronUp, Plus, Minus,
  Share2, Heart, Check, X, Info, DollarSign, Bus, User
} from 'lucide-react';



const getTipoSeguro = (transporte) => {
  const esAereo = transporte === 'Aéreo' || transporte === 'Aereo' || transporte === 'Avión';
  
  if (esAereo) {
    return {
      titulo: 'Seguro de Cancelación Flexible'
    };
  } else {
    return {
      titulo: 'Seguro de Cancelación por Enfermedad',
      descripcion: 'Cobertura en caso de enfermedad'
    };
  }
};


// ✅ Modal para seleccionar edad del menor
const ModalEdadMenor = ({ visible, onClose, onConfirm }) => {
  const [edad, setEdad] = useState(7);
  
  if (!visible) return null;
  
  const getCategoria = () => {
    if (edad >= 0 && edad <= 2) return { categoria: 'Sin costo', color: 'text-green-600', bg: 'bg-green-50' };
    if (edad >= 3 && edad <= 4) return { categoria: '50% del viaje', color: 'text-blue-600', bg: 'bg-blue-50' };
    if (edad >= 5 && edad <= 12) return { categoria: 'Precio completo', color: 'text-orange-600', bg: 'bg-orange-50' };
    return { categoria: 'Precio completo', color: 'text-purple-600', bg: 'bg-purple-50' };
  };
  
  const { categoria, color, bg } = getCategoria();
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 mt-2 overflow-hidden flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-2">
          ¿Qué edad tiene el menor?
        </h3>
        
        <p className="text-sm text-gray-600 mb-4">
          Máximo 17 años. Los menores tienen tarifas especiales según su edad.
        </p>
        
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Edad del menor
          </label>
          
          {/* Input de edad */}
          <div className="flex items-center gap-3 mb-4">
            <button
              onClick={() => setEdad(Math.max(0, edad - 1))}
              className="w-10 h-10 rounded-lg border-2 border-gray-300 flex items-center justify-center hover:border-[#2AA8B0] hover:bg-[#2AA8B0]/10 transition-colors"
            >
              −
            </button>
            
            <input
              type="number"
              min="0"
              max="17"
              value={edad}
              onChange={(e) => {
                const val = parseInt(e.target.value) || 0;
                if (val >= 0 && val <= 17) setEdad(val);
              }}
              className="flex-1 border-2 border-gray-300 rounded-lg px-4 py-2 text-center text-2xl font-bold focus:border-[#2AA8B0] focus:outline-none"
            />
            
            <button
              onClick={() => setEdad(Math.min(17, edad + 1))}
              className="w-10 h-10 rounded-lg border-2 border-gray-300 flex items-center justify-center hover:border-[#2AA8B0] hover:bg-[#2AA8B0]/10 transition-colors"
            >
              +
            </button>
          </div>
          
          {/* Tarifa según edad */}
          <div className={`p-3 rounded-lg ${bg}`}>
            <div className="text-sm text-gray-600 mb-1">Tarifa para esta edad:</div>
            <div className={`text-lg font-bold ${color}`}>
              {edad === 0 && '0 años - Sin costo'}
              {edad === 1 && '1 año - Sin costo'}
              {edad === 2 && '2 años - Sin costo'}
              {edad === 3 && '3 años - 50% del viaje'}
              {edad === 4 && '4 años - 50% del viaje'}
              {edad >= 5 && edad <= 12 && `${edad} años - Precio completo`}
              {edad > 12 && edad <= 17 && `${edad} años - Precio completo`}
            </div>
            {(edad === 0 || edad === 1 || edad === 2) && (
              <p className="text-xs text-gray-600 mt-2">
                ℹ️ Solo aplican gastos administrativos, seguros y cobertura de salud.
              </p>
            )}
            {(edad === 3 || edad === 4) && (
              <p className="text-xs text-gray-600 mt-2">
                ℹ️ Paga el 50% del viaje + gastos administrativos y seguros.
              </p>
            )}
          </div>
        </div>
        
        {/* Botones */}
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 border-2 border-gray-300 rounded-xl font-semibold hover:bg-gray-50 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={() => onConfirm(edad)}
            className="flex-1 px-4 py-3 bg-[#2AA8B0] text-white rounded-xl font-semibold hover:bg-[#1E3A5F] transition-colors"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};



function PaqueteDetail() {
  const { slug  } = useParams();
  const navigate = useNavigate();
  const { trackPaqueteView, pushToDataLayer } = useGTM();
  // ✅ NUEVO: Estado para saber si el menú está abierto
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const [faqPaquetes, setFaqPaquetes] = useState([]);
  const [loadingFAQ, setLoadingFAQ] = useState(true);
  const [paquete, setPaquete] = useState(null);
  const [imagenesDestino, setImagenesDestino] = useState([]);
  const [imagenPrincipal, setImagenPrincipal] = useState(0);
  const [mostrarCarruselMobile, setMostrarCarruselMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(0);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [showFAQ, setShowFAQ] = useState({});
  const [circuitos, setCircuitos] = useState([]);
  const [circuitosDesplegado, setCircuitosDesplegado] = useState(true);
  const [circuitoSeleccionado, setCircuitoSeleccionado] = useState(null);
  const [reservando, setReservando] = useState(false); // ← AGREGAR
  const [sessionData, setSessionData] = useState(null); // ← AGREGAR
  const [incluirSeguro, setIncluirSeguro] = useState(false);
  const [incluirCovid, setIncluirCovid] = useState(false);
  const [impuestos, setImpuestos] = useState(0);
  const [gastosAdministrativos, setGastosAdministrativos] = useState(0);
  const [reservaData, setReservaData] = useState({
    pasajeros: 1,
    fechaSeleccionada: '',
    tipoHabitacion: '',
    extras: [],
    menores: [] 
  });

  // ✅ NUEVO: Cargar FAQ dinámicas
const [preguntas, setPreguntas] = useState([]);

useEffect(() => {
  const fetchFAQ = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/faq-paquetes`);
      if (response.ok) {
        const data = await response.json();
        setPreguntas(data);
      }
    } catch (error) {
      console.error('Error al cargar FAQ:', error);
      // Fallback a preguntas por defecto si falla la API
      setPreguntas([
        {
          id: 1,
          pregunta: "¿Puedo modificar las fechas de mi viaje una vez comprado el paquete?",
          respuesta: "Sí, puedes modificar las fechas según disponibilidad y política de cambios. Se pueden aplicar cargos adicionales."
        },
        {
          id: 2,
          pregunta: "¿Qué incluye el paquete de viaje?",
          respuesta: "El paquete incluye transporte, alojamiento y régimen según se detalla en la descripción."
        },
        {
          id: 3,
          pregunta: "¿Ofrecen asistencia durante el viaje?",
          respuesta: "Sí, contamos con asistencia 24/7 durante todo el viaje y coordinadores locales en el destino."
        },
        {
          id: 4,
          pregunta: "¿Puedo pagar en cuotas?",
          respuesta: "Ofrecemos diferentes opciones de pago incluyendo financiación en cuotas sin interés."
        }
      ]);
    }
  };
  
  fetchFAQ();
}, []);

// ✅ NUEVO: Cargar FAQs de paquetes desde la BD
useEffect(() => {
  const fetchFAQs = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/faq-paquetes`);
      if (response.ok) {
        const data = await response.json();
        const faqsActivos = data
          .filter(faq => faq.activo)
          .sort((a, b) => a.orden - b.orden);
        setFaqPaquetes(faqsActivos);
      }
    } catch (error) {
      console.error('Error cargando FAQs:', error);
    } finally {
      setLoadingFAQ(false);
    }
  };
  
  fetchFAQs();
}, []);

  // ✅ Determinar pasajeros mínimos según singles
  const pasajerosMinimos = useMemo(() => {
    if (!paquete) return 1;
    
    const singlesValue = (paquete.singles || '').toLowerCase().trim();
    const permiteSingles = singlesValue === 'si' || singlesValue === 'sí';
    
    console.log('👤 Singles config:', {
      valor_bd: paquete.singles,
      normalizado: singlesValue,
      permite_singles: permiteSingles,
      minimo: permiteSingles ? 1 : 2
    });
    
    return permiteSingles ? 1 : 2;
  }, [paquete]);

  // ✅ 2. INICIALIZAR RESERVADATA CON EL MÍNIMO CORRECTO
  useEffect(() => {
    if (paquete) {
      setReservaData(prev => ({
        ...prev,
        pasajeros: Math.max(prev.pasajeros, pasajerosMinimos)
      }));
    }
  }, [paquete, pasajerosMinimos]);

  // Función para obtener información de precio
  const getPrecioInfo = () => {
    if (!paquete) {
      return { precio: 0, moneda: 'ARS', simbolo: '$', clase: 'text-gray-400' };
    }

    const monedaDB = paquete.moneda || '$';
    const esUSD = monedaDB === 'U$S' || monedaDB === 'USD';
    
    return {
      precio: parseFloat(paquete.tarifa || 0),
      moneda: esUSD ? 'USD' : 'ARS',
      simbolo: esUSD ? 'U$S' : '$',
      clase: esUSD ? 'text-blue-600' : 'text-green-600'
    };
  };


// Función para calcular precio final (memoizada)
// REEMPLAZA la función precioCalculado completa (líneas ~65-200) con esta versión corregida:

const precioCalculado = useMemo(() => {
  if (!paquete) return { 
    precioTotal: 0, 
    descuentoTotal: 0, 
    subtotal: 0,
    subtotalOriginal: 0,
    circuitoCosto: 0,
    detalles: [],
    // ✅ NUEVO: Soporte para monedas mixtas
    tieneMonedasMixtas: false,
    montoPesos: 0,
    montoDolares: 0
  };

  // ✅ Detectar si hay monedas mixtas
  const monedaPrincipal = paquete.moneda || '$';
  
  // Verificar tarifa adicional del paquete (viene de la BD)
  const tarifaAdicionalPaquete = parseFloat(paquete.tarifa_adicional) || 0;
  const monedaAdicionalPaquete = paquete.moneda_tarifa_adicional || '';
  const tieneTarifaAdicionalUSD = tarifaAdicionalPaquete > 0 && 
                                   (monedaAdicionalPaquete === 'U$S' || monedaAdicionalPaquete === 'USD');
  
  // Verificar circuito seleccionado
  const circuitoTieneUSD = circuitoSeleccionado && 
                           circuitoSeleccionado.precio_usd && 
                           parseFloat(circuitoSeleccionado.precio_usd) > 0;
  
  // Es mixta si: paquete en pesos Y (tiene tarifa adicional USD O circuito tiene USD)
  const esMonedaMixta = monedaPrincipal === '$' && (tieneTarifaAdicionalUSD || circuitoTieneUSD);
  
  // Determinar el monto en USD a usar
  const montoUSDPorPersona = circuitoTieneUSD 
    ? parseFloat(circuitoSeleccionado.precio_usd) 
    : tarifaAdicionalPaquete;

  console.log('💱 ANÁLISIS DE MONEDAS:', {
    moneda_principal: monedaPrincipal,
    tiene_circuito: !!circuitoSeleccionado,
    precio_usd_circuito: circuitoSeleccionado?.precio_usd,
    es_moneda_mixta: esMonedaMixta
  });

  // ✅ CORREGIDO: Determinar precio base según circuito seleccionado
  let precioBase = parseFloat(paquete.tarifa || 0);
  let precioParaDescuentos = precioBase; // Precio sobre el cual calcular descuentos
  
  // Si hay circuito seleccionado, usar su precio para los cálculos
  if (circuitoSeleccionado) {
    const precioCircuitoPesos = parseFloat(circuitoSeleccionado.precio) || 0;
    
    // Si el circuito tiene precio en pesos, usarlo para descuentos
    if (precioCircuitoPesos > 0) {
      precioParaDescuentos = precioCircuitoPesos;
      console.log('💰 Descuentos calculados sobre precio circuito:', precioParaDescuentos);
    }
  }

  const adultos = reservaData.pasajeros;
  const menores = reservaData.menores || [];
  const totalPersonas = adultos + menores.length;
  
  const subtotalOriginal = Math.round(precioParaDescuentos * adultos);
  const subtotal = subtotalOriginal;
  
  let descuentoTotal = 0;
  const detalles = [];

  // Descuento principal (calculado sobre precio del circuito si existe)
  if (paquete.descuento_principal_monto && parseFloat(paquete.descuento_principal_monto) > 0) {
    let descuentoMonto = 0;
    if (paquete.descuento_principal_tipo === 'porcentaje') {
      const porcentaje = parseFloat(paquete.descuento_principal_monto) / 100;
      descuentoMonto = Math.round(precioParaDescuentos * porcentaje * adultos);
    } else {
      descuentoMonto = parseFloat(paquete.descuento_principal_monto) * adultos;
    }
    
    descuentoTotal += descuentoMonto;
    detalles.push({
      tipo: 'principal',
      descripcion: `Descuento ${paquete.descuento_principal_monto}${paquete.descuento_principal_tipo === 'porcentaje' ? '%' : ''}`,
      monto: descuentoMonto,
      yaAplicado: true
    });
  }

  // Descuento 2do pasajero
  if (adultos >= 2 && paquete.descuento_2do_pasajero_monto && parseFloat(paquete.descuento_2do_pasajero_monto) > 0) {
    let descuento = 0;
    if (paquete.descuento_2do_pasajero_tipo === 'porcentaje') {
      descuento = (precioParaDescuentos * parseFloat(paquete.descuento_2do_pasajero_monto)) / 100;
    } else {
      descuento = parseFloat(paquete.descuento_2do_pasajero_monto);
    }
    descuentoTotal += descuento;
    detalles.push({
      tipo: '2do',
      descripcion: 'Descuento 2do pasajero',
      monto: descuento
    });
  }

  // Descuento 3er pasajero
  if (adultos === 3 && paquete.descuento_3er_pasajero_monto && parseFloat(paquete.descuento_3er_pasajero_monto) > 0) {
    let descuento = 0;
    if (paquete.descuento_3er_pasajero_tipo === 'porcentaje') {
      descuento = (precioParaDescuentos * parseFloat(paquete.descuento_3er_pasajero_monto)) / 100;
    } else {
      descuento = parseFloat(paquete.descuento_3er_pasajero_monto);
    }
    descuentoTotal += descuento;
    detalles.push({
      tipo: '3er',
      descripcion: 'Descuento 3er pasajero',
      monto: descuento
    });
  }

  // Cálculo de menores
let costoMenores = 0;
let descuentoFamilyPlan = 0;

  // ✅ Detectar si es aéreo
  const esAereo = paquete.transporte === 'Aéreo' || 
                paquete.transporte === 'Aereo' || 
                paquete.transporte === 'Avión';

  if (menores.length > 0) {
    menores.forEach((menor, index) => {
      let costoMenor = 0;
      
      if (esAereo) {
        // ✅ AÉREO: Todos los menores pagan como adultos
        costoMenor = precioParaDescuentos;
        console.log(`   ✈️ AÉREO - Menor ${index + 1}: Tarifa adulto = $${costoMenor}`);
      } else {
        // ✅ TERRESTRE: Aplicar descuentos por edad
        if (menor.edad >= 0 && menor.edad <= 2) {
          costoMenor = 0;
          console.log(`   ✅ Menor ${index + 1} (${menor.edad} años): SIN COSTO`);
        } else if (menor.edad >= 3 && menor.edad <= 4) {
          costoMenor = Math.round(precioParaDescuentos * 0.5);
          console.log(`   ✅ Menor ${index + 1} (${menor.edad} años): 50% = $${costoMenor}`);
        } else if (menor.edad >= 5 && menor.edad <= 12) {
          costoMenor = precioParaDescuentos;
          console.log(`   ✅ Menor ${index + 1} (${menor.edad} años): 100% = $${costoMenor}`);
        } else {
          costoMenor = precioParaDescuentos;
          console.log(`   ✅ Menor ${index + 1} (${menor.edad} años): 100% = $${costoMenor}`);
        }
      }
      
      costoMenores += costoMenor;
    });
    
    console.log(`   💰 Total menores: $${costoMenores}`);
    
    // Family Plan
    if (!esAereo && paquete.family_plan_activo) {
      const edadMaxima = paquete.family_plan_edad_maxima || 12;
      const adultosMinimos = paquete.family_plan_adultos_minimos || 2;
      const menoresMaximos = paquete.family_plan_menores_maximos || 2;
      const descuentoPorMenor = parseFloat(paquete.family_plan_descuento) || 0;
      const tipoDescuento = paquete.family_plan_tipo || 'fijo';
      
      if (adultos >= adultosMinimos && descuentoPorMenor > 0) {
        const menoresCalifican = menores
          .filter(m => m.edad >= 5 && m.edad <= edadMaxima)
          .slice(0, menoresMaximos);
        
        if (menoresCalifican.length > 0) {
          menoresCalifican.forEach(menor => {
            let descuento = 0;
            if (tipoDescuento === 'porcentaje') {
              descuento = (precioParaDescuentos  * descuentoPorMenor) / 100;
            } else {
              descuento = descuentoPorMenor;
            }
            descuentoFamilyPlan += descuento;
          });
          
          descuentoTotal += descuentoFamilyPlan;
          detalles.push({
            tipo: 'family',
            descripcion: `Family Plan (${menoresCalifican.length} ${menoresCalifican.length === 1 ? 'menor' : 'menores'})`,
            monto: descuentoFamilyPlan,
            edades: menoresCalifican.map(m => m.edad).join(', ')
          });
        }
      }
    }
  }

  // ✅ MANEJO DE MONEDAS MIXTAS
  let precioTotal = subtotal + costoMenores;
  let circuitoCosto = 0;
  let circuitoMoneda = null;
  let montoPesos = 0;
  let montoDolares = 0;

  if (esMonedaMixta) {
    // ✅ CASO ESPECIAL: Paquete en PESOS + USD adicional
    console.log('💱 MODO MONEDA MIXTA ACTIVADO');
    
    // Precio base en pesos (adultos + menores)
    montoPesos = precioTotal;
    
    // USD (del circuito o de tarifa_adicional del paquete)
    montoDolares = montoUSDPorPersona * totalPersonas;
    
    circuitoCosto = montoDolares;
    circuitoMoneda = 'USD';
    
    console.log('💵 Desglose mixto:', {
      pesos: montoPesos,
      dolares: montoDolares,
      total_personas: totalPersonas
    });
    
  } else if (circuitoSeleccionado) {
    // ✅ CASO NORMAL: Misma moneda
    const precioUSD = parseFloat(circuitoSeleccionado.precio_usd) || 0;
    const precioPesos = parseFloat(circuitoSeleccionado.precio) || 0;
    
    if (precioUSD > 0) {
      circuitoCosto = precioUSD * totalPersonas;
      circuitoMoneda = 'USD';
      precioTotal = circuitoCosto;
    } else if (precioPesos > 0) {
      circuitoCosto = precioPesos * totalPersonas;
      circuitoMoneda = 'ARS';
      precioTotal = circuitoCosto;
    }
  }

  // Descuentos (solo si NO es moneda mixta con USD)
  if (!esMonedaMixta) {
    const descuentosTotalesARestar = detalles.reduce((sum, d) => sum + d.monto, 0);
    precioTotal -= descuentosTotalesARestar;
    
    if (esMonedaMixta) {
      montoPesos -= descuentosTotalesARestar;
    }
  }

  // Impuestos y gastos (siempre en pesos)
  const impuestosTotal = impuestos > 0 ? impuestos * totalPersonas : 0;
  const gastosTotal = gastosAdministrativos > 0 ? gastosAdministrativos * totalPersonas : 0;
  
  if (esMonedaMixta) {
    montoPesos += impuestosTotal + gastosTotal;
  } else {
    precioTotal += impuestosTotal + gastosTotal;
  }

  // Extras (seguro y COVID - siempre en pesos)
  let costoSeguro = 0;
  if (incluirSeguro && paquete.tarifa_seguro && parseFloat(paquete.tarifa_seguro) > 0) {
    costoSeguro = parseFloat(paquete.tarifa_seguro) * totalPersonas;
  }

  let costoCovid = 0;
  if (incluirCovid && paquete.tarifa_covid && parseFloat(paquete.tarifa_covid) > 0) {
    costoCovid = parseFloat(paquete.tarifa_covid) * totalPersonas;
  }

  if (esMonedaMixta) {
    montoPesos += costoSeguro + costoCovid;
  } else {
    precioTotal += costoSeguro + costoCovid;
  }

  const precioFinalConExtras = esMonedaMixta ? 0 : precioTotal;

  return { 
    subtotal,
    subtotalOriginal,
    descuentoTotal, 
    precioTotal: precioFinalConExtras,
    circuitoCosto,
    circuitoMoneda,
    impuestos: impuestosTotal,
    gastosAdministrativos: gastosTotal,
    costoMenores,
    descuentoFamilyPlan,
    costoSeguro,
    costoCovid,
    detalles,
    // ✅ NUEVO: Datos para monedas mixtas
    tieneMonedasMixtas: esMonedaMixta,
    montoPesos: Math.round(montoPesos),
    montoDolares: Math.round(montoDolares)
  };

}, [paquete, reservaData.pasajeros, reservaData.menores, circuitoSeleccionado, 
    gastosAdministrativos, impuestos, incluirSeguro, incluirCovid]);

  // Formatear precio
  const formatearPrecio = (precio, simbolo) => {
    return `${simbolo} ${Number(precio).toLocaleString('es-AR', { 
      minimumFractionDigits: 0,
      maximumFractionDigits: 0 
    })}`;
  };

  // Cargar datos del paquete
useEffect(() => {
  const fetchPaqueteData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/paquetes/${slug}`);
      if (!response.ok) {
        setError('Paquete no encontrado');
        return;
      }
      
      const data = await response.json();
      
      // 🔍 DEBUG: Ver exactamente qué trae de la BD
      console.log('📦 DATOS CRUDOS DEL PAQUETE:', {
        id: data.id,
        titulo: data.titulo,
        tarifa_raw: data.tarifa,
        tarifa_tipo: typeof data.tarifa,
        moneda: data.moneda,
        gastos_pesos_raw: data.gastos_pesos,
        gastos_dolares_raw: data.gastos_dolares
      });
      
      setPaquete(data);
      trackPaqueteView(data);

      // ✅ CARGAR GASTOS - UNA SOLA VEZ, NO POR PASAJERO
      const monedaPaquete = data.moneda || '$';
      let gastosFinal = 0;
      
      if (monedaPaquete === 'U$S' || monedaPaquete === 'USD') {
        gastosFinal = parseFloat(data.gastos_dolares) || 0;
        console.log('💵 Gastos administrativos (USD) - una sola vez:', gastosFinal);
      } else {
        gastosFinal = parseFloat(data.gastos_pesos) || 0;
        console.log('💵 Gastos administrativos (ARS) - una sola vez:', gastosFinal);
      }
      
      setGastosAdministrativos(gastosFinal);

      // Cargar imágenes desde la BD (solo las que existen)
      if (data.carpeta_imagenes && data.cantidad_imagenes > 0) {
        const loadImages = async () => {
          const imgs = [];
          
          // Probar cada imagen para ver si existe
          for (let i = 1; i <= data.cantidad_imagenes; i++) {
            const imgUrl = `/images/destinos/${data.carpeta_imagenes}/${i}.webp`;
            
            try {
              // Verificar si la imagen existe haciendo un fetch HEAD
              const response = await fetch(imgUrl, { method: 'HEAD' });
              if (response.ok) {
                imgs.push(imgUrl);
              }
            } catch (error) {
              console.warn(`⚠️ Imagen ${i} no existe: ${imgUrl}`);
            }
          }
          
          setImagenesDestino(imgs);
          console.log(`🖼️ ${imgs.length} de ${data.cantidad_imagenes} imágenes cargadas para ${data.carpeta_imagenes}`);
        };
        
        loadImages();
      } else {
        // Fallback
        try {
          const imgs = getAllDestinoImages(data.destino_nombre);
          setImagenesDestino(imgs);
        } catch (error) {
          console.warn('⚠️ No se pudieron cargar imágenes:', error);
          setImagenesDestino([]);
        }
      }
      
      // 2. Cargar circuitos e impuestos DIRECTO desde API externa
      try {
        console.log('🔄 Cargando circuitos desde API externa...');
        
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 15000); // 15 segundos
        
        const externosResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/viajes`,
          { signal: controller.signal }
        );
        
        clearTimeout(timeoutId);
        
        if (externosResponse.ok) {
          const externosData = await externosResponse.json();

          if (externosData.estado === 1 && externosData.viajes) {
            console.log('📦 DEBUG: Buscando viaje con id_externo:', data.id_externo);
            console.log('📦 DEBUG: Primer viaje de la API:', Object.keys(externosData.viajes)[0], externosData.viajes[Object.keys(externosData.viajes)[0]]);
            let viajeExterno = null;
            const viajesArray = Object.values(externosData.viajes);

            // 🔍 Buscar por id_externo
            if (data.id_externo) {
              const idLimpio = String(data.id_externo).replace(/^["']|["']$/g, '').trim();
              
              viajeExterno = externosData.viajes[idLimpio] ||
                            externosData.viajes[`"${idLimpio}"`] ||
                            externosData.viajes[`'${idLimpio}'`];
            }

            // 🔍 Buscar en array si no encontró
            if (!viajeExterno && data.id_externo) {
              const idLimpio = String(data.id_externo).replace(/^["']|["']$/g, '').trim();
              viajeExterno = viajesArray.find(v => {
                const viajeId = String(v.id).replace(/^["']|["']$/g, '').trim();
                return viajeId === idLimpio;
              });
            }

            // 🔍 Último recurso: buscar por destino + fecha + duración
            if (!viajeExterno) {
              const fechaBuscar = data.fecha_salida?.split('T')[0];
              viajeExterno = viajesArray.find(v => {
                const mismoDestino = v.destino?.nombre?.toLowerCase().trim() === 
                                    data.destino_nombre?.toLowerCase().trim();
                const mismaFecha = v.fecha_de_salida === fechaBuscar;
                const mismaDuracion = v.duracion?.toLowerCase().trim() === 
                                      data.duracion?.toLowerCase().trim();
                return mismoDestino && mismaFecha && mismaDuracion;
              });
            }

            if (viajeExterno) {
              console.log('✅ Viaje encontrado en API externa:', viajeExterno.id);
              
              // ✅ CARGAR CIRCUITOS (extras)
              if (viajeExterno.extras && viajeExterno.extras.length > 0) {
                console.log(`🎯 ${viajeExterno.extras.length} circuitos disponibles`);
                setCircuitos(viajeExterno.extras);
                setCircuitoSeleccionado(viajeExterno.extras[0]); // Seleccionar el primero por defecto
              } else {
                console.log('⚠️ No hay circuitos disponibles');
              }
              
              // ✅ CARGAR IMPUESTOS
              if (viajeExterno.impuestos && parseFloat(viajeExterno.impuestos) > 0) {
                console.log(`💰 Impuestos: ${viajeExterno.impuestos}`);
                setImpuestos(parseFloat(viajeExterno.impuestos));
              }
            } else {
              console.warn('⚠️ No se encontró el viaje en la API externa');
            }
          }
        }
      } catch (externosError) {
        if (externosError.name === 'AbortError') {
          console.warn('⏱️ Timeout cargando circuitos (>15s)');
        } else {
          console.warn('⚠️ Error cargando circuitos:', externosError.message);
        }
        // Continuar sin circuitos si falla
      }
      
    } catch (error) {
      console.error('Error:', error);
      setError('No se pudo cargar la información del paquete');
    } finally {
      setLoading(false);
    }
  };

  if (slug) {
    fetchPaqueteData();
  }
}, [slug]);


// ✅ Cargar imágenes de forma optimista (sin verificar cada una)
useEffect(() => {
  if (!paquete) return;
  
  console.log('🔍 DEBUG USEEFFECT: Verificando datos del paquete', {
    carpeta: paquete.carpeta_imagenes,
    cantidad: paquete.cantidad_imagenes,
    tiene_carpeta: !!paquete.carpeta_imagenes,
    tiene_cantidad: !!paquete.cantidad_imagenes
  });

  if (paquete.carpeta_imagenes && paquete.cantidad_imagenes > 0) {
    console.log(`🖼️ Cargando ${paquete.cantidad_imagenes} imágenes desde BD para carpeta: ${paquete.carpeta_imagenes}`);
    
    // ✅ OPTIMIZACIÓN: Generar URLs sin verificar (carga instantánea)
    const imgs = Array.from({ length: paquete.cantidad_imagenes }, (_, i) => 
      `/images/destinos/${paquete.carpeta_imagenes}/${i + 1}.webp`
    );
    
    setImagenesDestino(imgs);
    console.log(`✅ ${imgs.length} imágenes cargadas (optimista) para ${paquete.carpeta_imagenes}`);
    
  } else {
    // Fallback al mapper si no hay datos en BD
    console.log('⚠️ USANDO FALLBACK - carpeta o cantidad no disponibles');
    try {
      const imgs = getAllDestinoImages(paquete.destino_nombre);
      setImagenesDestino(imgs);
      console.log(`🖼️ ${imgs.length} imágenes cargadas (fallback) para ${paquete.destino_nombre}`);
    } catch (error) {
      console.warn('⚠️ No se pudieron cargar imágenes');
    }
  }
}, [paquete]);


// ✅ NUEVO: Cargar FAQ dinámicas
useEffect(() => {
  const fetchFAQ = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/faq-paquetes`);
      if (response.ok) {
        const data = await response.json();
        setPreguntas(data);
      }
    } catch (error) {
      console.error('Error al cargar FAQ:', error);
      // Fallback a preguntas por defecto si falla la API
      setPreguntas([
        {
          id: 1,
          pregunta: "¿Puedo modificar las fechas de mi viaje una vez comprado el paquete?",
          respuesta: "Sí, puedes modificar las fechas según disponibilidad y política de cambios. Se pueden aplicar cargos adicionales."
        },
        {
          id: 2,
          pregunta: "¿Qué incluye el paquete de viaje?",
          respuesta: "El paquete incluye transporte, alojamiento y régimen según se detalla en la descripción."
        },
        {
          id: 3,
          pregunta: "¿Ofrecen asistencia durante el viaje?",
          respuesta: "Sí, contamos con asistencia 24/7 durante todo el viaje y coordinadores locales en el destino."
        },
        {
          id: 4,
          pregunta: "¿Puedo pagar en cuotas?",
          respuesta: "Ofrecemos diferentes opciones de pago incluyendo financiación en cuotas sin interés."
        }
      ]);
    }
  };
  
  fetchFAQ();
}, []);



  // ✅ NUEVO: Limpiar menores si el paquete es aéreo
useEffect(() => {
  if (paquete) {
    const esAereo = paquete.transporte === 'Aéreo' || 
                    paquete.transporte === 'Aereo' || 
                    paquete.transporte === 'Avión';
    
    if (esAereo && reservaData.menores.length > 0) {
      console.log('🚫 Paquete aéreo detectado: limpiando menores');
      setReservaData(prev => ({
        ...prev,
        menores: []
      }));
    }
  }
}, [paquete]);


// ✅ Liberar bloqueo si el usuario abandona la página
useEffect(() => {
  const handleUnload = async () => {
    const sessionId = localStorage.getItem('reserva_session_id');
    if (sessionId) {
      // Usar sendBeacon para garantizar que se envíe incluso al cerrar
      const url = `${process.env.REACT_APP_API_URL}/liberar-disponibilidad`;
      const data = JSON.stringify({ session_id: sessionId });
      
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([data], { type: 'application/json' }));
      }
      
      localStorage.removeItem('reserva_session_id');
      localStorage.removeItem('reserva_timestamp');
    }
  };
  
  window.addEventListener('beforeunload', handleUnload);
  
  return () => {
    window.removeEventListener('beforeunload', handleUnload);
  };
}, []);


const handleReserva = async () => {
  if (!circuitoSeleccionado) {
    alert('Por favor selecciona un circuito antes de reservar');
    setCircuitosDesplegado(true);
    return;
  }
  
  // Verificar autenticación
  const token = localStorage.getItem('token');
  if (!token) {
    alert('Debes iniciar sesión para reservar');
    navigate('/login');
    return;
  }
  
  try {
    setReservando(true);
    console.log('🎫 Iniciando proceso de reserva...');

    // Limpiar ID externo
    let idExternoFinal = paquete.id_externo;
    idExternoFinal = String(idExternoFinal).replace(/^["']|["']$/g, '').trim();
    
    console.log('📦 Datos de reserva:');
    console.log('   Paquete ID:', paquete.id);
    console.log('   ID Externo:', idExternoFinal);

    // Llamar al backend Node.js (que hace proxy al PHP)
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/crear-sesion-reservas`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          paquete_id: paquete.id,
          id_externo: idExternoFinal
        })
      }
    );
    
    console.log('📥 Response status:', response.status);
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error creando sesión');
    }
    
    const data = await response.json();
    console.log('✅ Sesión creada:', data);
    
    if (!data.success || !data.sessionId) {
      throw new Error('Respuesta inválida del servidor');
    }
    
    // Usar directamente la URL del backend (ya incluye los datos de la BD)
    console.log('🔄 Redirigiendo a:', data.redirectUrl);
    window.location.href = data.redirectUrl;
    
  } catch (error) {
    console.error('❌ Error en reserva:', error);
    alert(`Error al procesar la reserva: ${error.message}\n\nPor favor, intentá nuevamente.`);
  } finally {
    setReservando(false);
  }
};



{/*  // Función para calcular precio con descuentos
const calcularPrecioFinal = () => {
  const precioInfo = getPrecioInfo();
  const precioBase = precioInfo.precio;
  const numPasajeros = reservaData.pasajeros;
  
  let precioTotal = precioBase * numPasajeros;
  let descuentoTotal = 0;
  const detalles = [];

  // Descuento principal (aplica a TODOS los pasajeros)
  if (paquete.descuento_principal_monto && paquete.descuento_principal_monto > 0) {
    const ahora = new Date();
    const desde = new Date(paquete.descuento_principal_desde);
    const hasta = new Date(paquete.descuento_principal_hasta);
    
    if (ahora >= desde && ahora <= hasta) {
      let descuento = 0;
      if (paquete.descuento_principal_tipo === 'porcentaje') {
        descuento = (precioBase * numPasajeros * paquete.descuento_principal_monto) / 100;
      } else if (paquete.descuento_principal_tipo === 'fijo') {
        descuento = paquete.descuento_principal_monto * numPasajeros;
      }
      descuentoTotal += descuento;
      detalles.push({
        tipo: 'principal',
        descripcion: paquete.descuento_principal_descripcion || 'Descuento promocional',
        monto: descuento
      });
    }
  }

  // Descuento 2do pasajero (solo si hay 2+ pasajeros)
  if (numPasajeros >= 2 && paquete.descuento_2do_pasajero_monto && paquete.descuento_2do_pasajero_monto > 0) {
    let descuento = 0;
    if (paquete.descuento_2do_pasajero_tipo === 'porcentaje') {
      descuento = (precioBase * paquete.descuento_2do_pasajero_monto) / 100;
    } else if (paquete.descuento_2do_pasajero_tipo === 'fijo') {
      descuento = paquete.descuento_2do_pasajero_monto;
    }
    descuentoTotal += descuento;
    detalles.push({
      tipo: '2do',
      descripcion: 'Descuento 2do pasajero',
      monto: descuento
    });
  }

  // Descuento 3er pasajero (aplica al 3er pasajero Y TODOS LOS SIGUIENTES)
  if (numPasajeros >= 3 && paquete.descuento_3er_pasajero_monto && paquete.descuento_3er_pasajero_monto > 0) {
    let descuento = 0;
    const cantidadPasajerosConDescuento = numPasajeros - 2; // Del 3ro en adelante
    
    if (paquete.descuento_3er_pasajero_tipo === 'porcentaje') {
      // Porcentaje sobre cada pasajero del 3ro en adelante
      descuento = (precioBase * paquete.descuento_3er_pasajero_monto / 100) * cantidadPasajerosConDescuento;
    } else if (paquete.descuento_3er_pasajero_tipo === 'fijo') {
      // Monto fijo por cada pasajero del 3ro en adelante
      descuento = paquete.descuento_3er_pasajero_monto * cantidadPasajerosConDescuento;
    }
    
    descuentoTotal += descuento;
    detalles.push({
      tipo: '3er',
      descripcion: cantidadPasajerosConDescuento === 1 
        ? 'Descuento 3er pasajero' 
        : `Descuento ${cantidadPasajerosConDescuento} pasajeros (del 3ro en adelante)`,
      monto: descuento
    });
  }

  // Agregar circuito
  const precioCircuito = circuitoSeleccionado?.precio_usd && circuitoSeleccionado.precio_usd !== '0'
    ? parseFloat(circuitoSeleccionado.precio_usd) * numPasajeros
    : 0;

  precioTotal = precioTotal - descuentoTotal + precioCircuito;

  return {
    precioTotal: Math.max(0, precioTotal),
    descuentoTotal,
    detalles,
    precioOriginal: precioBase * numPasajeros,
    precioCircuito
  };
}; */}

  const toggleFAQ = (index) => {
    setShowFAQ(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handlePasajerosChange = (operacion) => {
    setReservaData(prev => {
      let nuevaCantidad = prev.pasajeros;
      const maxCupos = Math.min(paquete?.disponibilidad || 5, 5);
      
      if (operacion === 'increase' && nuevaCantidad < maxCupos) {
        nuevaCantidad++;
      } else if (operacion === 'decrease' && nuevaCantidad > pasajerosMinimos) {
        nuevaCantidad--;
      }
      return { ...prev, pasajeros: nuevaCantidad };
    });
  };

  // ✅ Estado para modal de edad
  const [modalEdadVisible, setModalEdadVisible] = useState(false);

// ✅ Agregar menor - ajustar adultos automáticamente
const handleAgregarMenor = (edad) => {
  setReservaData(prev => {
    const nuevosMenores = [...prev.menores, { edad, id: Date.now() }];
    
    // ✅ Si es el primer menor y hay 2 adultos, bajar a 1 adulto
    let nuevosAdultos = prev.pasajeros;
    if (prev.menores.length === 0 && prev.pasajeros === 2 && pasajerosMinimos === 2) {
      nuevosAdultos = 1;
      console.log('✅ Primer menor agregado: bajando adultos de 2 a 1');
    }
    
    return {
      ...prev,
      pasajeros: nuevosAdultos,
      menores: nuevosMenores
    };
  });
  
  setModalEdadVisible(false);
  console.log('✅ Menor agregado:', edad, 'años');
};

// ✅ Quitar último menor - ajustar adultos automáticamente
const handleQuitarMenor = () => {
  setReservaData(prev => {
    const nuevosMenores = prev.menores.slice(0, -1);
    
    // ✅ Si era el último menor y había 1 adulto, volver a 2 adultos
    let nuevosAdultos = prev.pasajeros;
    if (prev.menores.length === 1 && prev.pasajeros === 1 && pasajerosMinimos === 2) {
      nuevosAdultos = 2;
      console.log('✅ Último menor quitado: subiendo adultos de 1 a 2');
    }
    
    return {
      ...prev,
      pasajeros: nuevosAdultos,
      menores: nuevosMenores
    };
  });
};

  // ✅ Cambiar edad de un menor
  const handleCambiarEdadMenor = (index, nuevaEdad) => {
    setReservaData(prev => ({
      ...prev,
      menores: prev.menores.map((m, i) => 
        i === index ? { ...m, edad: nuevaEdad } : m
      )
    }));
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2AA8B0] mx-auto mb-4"></div>
          <p className="text-gray-600">Cargando información del paquete...</p>
        </div>
      </div>
    );
  }

  if (error || !paquete) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Paquete no encontrado</h2>
          <p className="text-gray-600 mb-6">{error || 'El paquete que buscas no existe'}</p>
          <button
            onClick={() => navigate('/paquetes')}
            className="bg-[#2AA8B0] text-white px-6 py-3 rounded-lg hover:bg-[#1E3A5F] transition-colors"
          >
            Ver todos los paquetes
          </button>
        </div>
      </div>
    );
  }

  const precioInfo = getPrecioInfo();

  // Breadcrumb items
  const breadcrumbItems = [
    { label: 'INICIO', link: '/home' },
    { label: 'DESTINOS', link: '/paquetes' },
    { label: paquete.destino_nombre?.toUpperCase() || 'DESTINO', link: null },
    { label: paquete.titulo?.toUpperCase() || 'PAQUETE', link: null }
  ];


  return (
    <>
      <div className="overflow-x-hidden w-full">
        <Helmet>
          <title>{paquete.titulo} | Noche y Día Turismo</title>
          <meta name="description" content={paquete.descripcion} />
        </Helmet>
        
        <StandardNavbar onMenuToggle={setIsMenuOpen} />
        <Breadcrumb items={breadcrumbItems} />
        
        <div className="min-h-screen bg-gray-50 pt-20 pb-32 lg:pb-0 overflow-x-hidden">
          {/* Header del paquete */}
          <div className="bg-white">
            <div className="container mx-auto px-4 py-6">
              <div className="flex flex-col lg:flex-row gap-8">
                
                {/* Galería de imágenes */}
                <div className="lg:w-2/3">
                  
                  {/* ✅ INFO DEL PAQUETE - SOLO MOBILE - ARRIBA DE LAS IMÁGENES */}
                  <div className="lg:hidden mb-4 bg-gradient-to-br from-[#2AA8B0] to-[#1E3A5F] rounded-2xl shadow-lg p-4 text-white">
                    <h2 className="text-xl font-bold mb-3">{paquete.titulo}</h2>
                    
                    <div className="grid grid-cols-2 gap-2">
                      <div className="flex items-center gap-2">
                        <MapPin size={14} className="flex-shrink-0" />
                        <span className="text-sm">{paquete.destino_nombre}</span>
                      </div>
                      
                      <div className="flex items-center gap-2">
                        <Calendar size={14} className="flex-shrink-0" />
                        <span className="text-sm">
                          {paquete.fecha_salida ? 
                            new Date(paquete.fecha_salida).toLocaleDateString('es-ES', { 
                              day: '2-digit', 
                              month: '2-digit',
                              year: 'numeric'
                            }) : 
                            'Consultar'
                          }
                        </span>
                      </div>
                      
                      {paquete.disponibilidad && (
                        <div className="flex items-center gap-2">
                          <Users size={14} className="flex-shrink-0" />
                          <span className="text-sm">{paquete.disponibilidad} lugares</span>
                        </div>
                      )}
                      
                      {paquete.hotel && (
                        <div className="flex items-center gap-2">
                          <Hotel size={14} className="flex-shrink-0" />
                          <span className="text-sm truncate">{paquete.hotel}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ✅ INDICADOR DE SCROLL - LADO IZQUIERDO LARGO */}
                  <div className="md:hidden fixed bottom-44 left-4 z-30 animate-bounce pointer-events-none">
                    <div className="bg-[#2AA8B0] text-white px-2 py-3 rounded-full shadow-lg flex flex-col items-center gap-2" style={{ minHeight: '80px' }}>
                      <span className="text-xs font-bold whitespace-nowrap transform -rotate-0 writing-mode-vertical">Ver más</span>
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7-7-7" />
                      </svg>
                    </div>
                  </div>

                  {/* Galería de imágenes */}
                  <div className="relative">
                    {/* Imagen principal - SE MUESTRA SI SELECCIONAN UNA IMAGEN */}
                    <div className={`relative h-96 rounded-xl overflow-hidden transition-all ${
                      mostrarCarruselMobile ? 'block' : 'hidden'
                    } md:block`}>
                      <img 
                        src={imagenesDestino[imagenPrincipal] || paquete.imagen || '/images/placeholder.jpg'} 
                        alt={`${paquete.titulo} - Imagen ${imagenPrincipal + 1}`}
                        className="w-full h-full object-cover object-center"
                        onError={(e) => {
                          e.target.src = '/images/placeholder.jpg';
                        }}
                      />
                      
                      {/* Botones de navegación */}
                      {imagenesDestino.length > 1 && (
                        <>
                          <button
                            onClick={() => setImagenPrincipal(prev => prev === 0 ? imagenesDestino.length - 1 : prev - 1)}
                            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-lg transition-all"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                          </button>
                          <button
                            onClick={() => setImagenPrincipal(prev => prev === imagenesDestino.length - 1 ? 0 : prev + 1)}
                            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-lg transition-all"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                          </button>
                          
                          {/* Indicador de imagen actual */}
                          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/50 text-white px-3 py-1 rounded-full text-sm">
                            {imagenPrincipal + 1} / {imagenesDestino.length}
                          </div>
                        </>
                      )}
                    </div>
                    
                    {/* Miniaturas 
                    {imagenesDestino.length > 1 && (
                      <div className="grid grid-cols-6 gap-2 mt-4">
                        {imagenesDestino.slice(0, 6).map((img, index) => (
                          <button
                            key={index}
                            onClick={() => setImagenPrincipal(index)}
                            className={`relative rounded-lg overflow-hidden border-2 transition-all ${
                              imagenPrincipal === index ? 'border-[#2AA8B0] shadow-lg' : 'border-transparent hover:border-gray-300'
                            }`}
                          >
                            <img 
                              src={img} 
                              alt={`Miniatura ${index + 1}`}
                              className="w-full h-20 object-cover"
                              onError={(e) => {
                                e.target.src = '/images/placeholder.jpg';
                              }}
                            />
                            {imagenPrincipal === index && (
                              <div className="absolute inset-0 bg-[#2AA8B0]/20"></div>
                            )}
                          </button>
                        ))}
                      </div>
                    )}*/}
                  </div>
                  
                  {/* Thumbnails - MÁS DESTACADAS EN MOBILE */}
                  {imagenesDestino.length > 1 && (
                    <div className="relative mt-4">
                      {/* Indicador para mobile */}
                      <div className="md:hidden text-xs text-gray-600 mb-2 flex items-center gap-2 bg-blue-50 p-2 rounded-lg">
                        <span>👉</span>
                        <span className="font-medium">Desliza para ver las {imagenesDestino.length} fotos del destino</span>
                      </div>
                      <div className="flex gap-2 overflow-x-auto pb-2">
                        {imagenesDestino.map((img, index) => (
                          <button
                            key={index}
                            onClick={() => {
                              // Si toca la misma imagen que ya está seleccionada, ocultar carrusel
                              if (imagenPrincipal === index && mostrarCarruselMobile) {
                                setMostrarCarruselMobile(false);
                              } else {
                                // Si toca otra imagen o el carrusel está oculto, mostrar
                                setImagenPrincipal(index);
                                setMostrarCarruselMobile(true);
                              }
                            }}
                            className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all ${
                              imagenPrincipal === index ? 'border-[#2AA8B0]' : 'border-gray-200'
                            }`}
                          >
                            <img 
                              src={img} 
                              alt={`Vista ${index + 1}`} 
                              className="w-full h-full object-cover object-center"
                              onError={(e) => {
                                e.target.src = '/images/placeholder.jpg';
                              }}
                            />
                          </button>
                        ))}
                      </div>
                    </div>
                  )}



                  {/* SECCIÓN DE DETALLES DEL VIAJE */}
                  <div className="mt-8 bg-white rounded-2xl shadow-lg p-6 border-l-4 border-[#2AA8B0]">
                    <h3 className="text-xl font-bold text-gray-900 mb-4">Detalles del viaje</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {/* Transporte */}
                    {paquete.transporte && (
                      <div className="flex flex-col items-center p-4 bg-blue-50 rounded-xl">
                        {(() => {
                          const transporte = (paquete.transporte || '').toLowerCase();
                          const esAereo = transporte.includes('aéreo') || 
                                          transporte.includes('aereo') || 
                                          transporte.includes('avión') || 
                                          transporte.includes('avion');
                          
                          return esAereo ? (
                            <Plane size={24} className="text-[#2AA8B0] mb-2" />
                          ) : (
                            <Bus size={24} className="text-[#2AA8B0] mb-2" />
                          );
                        })()}
                        <span className="text-xs text-gray-500 mb-1">Transporte</span>
                        <span className="text-sm font-semibold text-gray-900 text-center">
                          {paquete.transporte}
                        </span>
                      </div>
                    )}

                      {/* Duración */}
                      {paquete.duracion && (
                        <div className="flex flex-col items-center p-4 bg-green-50 rounded-xl">
                          <Clock size={24} className="text-[#2AA8B0] mb-2" />
                          <span className="text-xs text-gray-500 mb-1">Duración</span>
                          <span className="text-sm font-semibold text-gray-900 text-center">
                            {paquete.duracion}
                          </span>
                        </div>
                      )}

                      {/* Régimen 
                      {paquete.regimen && (
                        <div className="flex flex-col items-center p-4 bg-orange-50 rounded-xl">
                          <Utensils size={24} className="text-[#2AA8B0] mb-2" />
                          <span className="text-xs text-gray-500 mb-1">Régimen</span>
                          <span className="text-sm font-semibold text-gray-900 text-center">
                            {paquete.regimen}
                          </span>
                        </div>
                      )}*/}

                      {/* Transfer (SIEMPRE incluido en viajes aéreos) */}
                      {(paquete.transporte === 'Aéreo' || paquete.transporte === 'Aereo' || paquete.transporte === 'Avión') && (
                        <div className="flex flex-col items-center p-4 bg-orange-50 rounded-xl">
                          <Plane size={24} className="text-[#2AA8B0] mb-2" />
                          <span className="text-xs text-gray-500 mb-1">Transfer</span>
                          <span className="text-sm font-semibold text-gray-900 text-center">
                            In/Out incluido
                          </span>
                        </div>
                      )}

                      {/* Coordinador */}
                      {paquete.incluye_coordinador && (
                        <div className="flex flex-col items-center p-4 bg-purple-50 rounded-xl">
                          <User size={24} className="text-[#2AA8B0] mb-2" />
                          <span className="text-xs text-gray-500 mb-1">Coordinador</span>
                          <span className="text-sm font-semibold text-gray-900 text-center">
                            Incluido
                          </span>
                        </div>
                      )}

                      {/* Asistencia COVID (solo si está incluida gratis) */}
                      {(!paquete.tarifa_covid || parseFloat(paquete.tarifa_covid) === 0) && (
                        <div className="flex flex-col items-center p-4 bg-green-50 rounded-xl">
                          <Check size={24} className="text-green-600 mb-2" />
                          <span className="text-xs text-gray-500 mb-1">Cobertura de Salud</span>
                          <span className="text-sm font-semibold text-green-600 text-center">
                            ✓ Incluida
                          </span>
                        </div>
                      )}

                    </div>
                  </div>

                  {/* SECCIÓN DE CIRCUITOS/EXTRAS */}
                  {circuitos.length > 0 && (
                    <div className="mt-8 bg-white rounded-2xl shadow-lg overflow-hidden">
                      {/* Header con desplegable funcional */}
                      <button
                        onClick={() => setCircuitosDesplegado(!circuitosDesplegado)}
                        className="w-full bg-[#1E3A5F] text-white p-4 flex items-center justify-between hover:bg-[#152a47] transition-colors"
                      >
                        <div className="flex items-center gap-3">
                          <Hotel size={24} />
                          <h3 className="text-xl font-bold">{paquete.hotel || 'Hotel'}</h3>
                        </div>
                        <div className="text-white">
                          Click para {circuitosDesplegado ? 'ocultar' : 'desplegar'} {circuitosDesplegado ? '▲' : '▼'}
                        </div>
                      </button>

                      {/* Contenido desplegable */}
                      {circuitosDesplegado && (
                        <>
                          {/* Categoría */}
                          <div className="bg-gray-100 px-4 py-2">
                            <p className="text-sm text-gray-600">Habitación Categoría Standard.</p>
                          </div>

                          {/* Grid de circuitos */}
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
                            {circuitos.map((circuito, index) => {
                            // Determinar si el circuito tiene precio
                            const precioUSD = circuito.precio_usd && parseFloat(circuito.precio_usd) > 0 
                              ? parseFloat(circuito.precio_usd) 
                              : 0;
                            const precioPesos = circuito.precio && parseFloat(circuito.precio) > 0
                              ? parseFloat(circuito.precio)
                              : 0;
                            
                            const precioBasePaquete = parseFloat(paquete.tarifa || 0);
                            const impuestosPorPersona = parseFloat(impuestos || 0);
                            
                            // ✅ Determinar moneda del CIRCUITO (no del paquete)
                            let precioAMostrar = 0;
                            let monedaCircuito = '$';  // ← RENOMBRADO para mayor claridad
                            let esIncluido = false;
                            
                            if (precioUSD > 0) {
                              precioAMostrar = precioUSD;
                              monedaCircuito = 'U$S';  // ← CIRCUITO EN DÓLARES
                            } else if (precioPesos > 0) {
                              precioAMostrar = precioPesos;
                              monedaCircuito = '$';     // ← CIRCUITO EN PESOS
                            } else {
                              // Sin precio = usar precio base del paquete
                              precioAMostrar = precioBasePaquete;
                              monedaCircuito = paquete.moneda || '$';
                              esIncluido = true;
                            }
                            
                            // ✅ CALCULAR TOTAL CON IMPUESTOS
                            const totalPorPersona = precioAMostrar + impuestosPorPersona;
                            
                            return (
                              <div 
                                key={circuito.id} 
                                className={`rounded-lg p-4 border-2 transition-all ${
                                  circuitoSeleccionado?.id === circuito.id
                                    ? 'bg-blue-100 border-blue-500'
                                    : 'bg-blue-50 border-blue-200 hover:border-blue-400'
                                }`}
                              >
                                {/* ✅ ÁREA CLICKEABLE PARA SELECCIONAR CIRCUITO */}
                                <div 
                                  className="cursor-pointer"
                                  onClick={() => setCircuitoSeleccionado(circuito)}
                                >
                                  <div className="flex justify-between items-start mb-3">
                                    <span className="font-semibold text-gray-800">{circuito.nombre}</span>
                                    <div className="text-right">
                                      {esIncluido ? (
                                        <>
                                          {/* Circuito incluido */}
                                          <div className="text-xs text-gray-500 mb-1">Precio base:</div>
                                          <div className="text-lg font-bold text-gray-700">
                                            {monedaCircuito} {Number(precioAMostrar).toLocaleString('es-AR')}
                                          </div>
                                          
                                          {/* ✅ Impuestos - USAR MONEDA DEL CIRCUITO */}
                                          {impuestosPorPersona > 0 && (
                                            <div className="text-xs text-orange-600 mt-1">
                                              + Impuestos: {monedaCircuito} {impuestosPorPersona.toLocaleString('es-AR')}
                                            </div>
                                          )}
                                          
                                          {/* ✅ Total CON impuestos */}
                                          <div className="text-sm font-bold text-gray-800 mt-1 pt-1 border-t border-gray-300">
                                            Total: {monedaCircuito} {totalPorPersona.toLocaleString('es-AR')}
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          {/* Circuito con precio adicional - AHORA CON AMBAS MONEDAS SI APLICA */}
                                          <div className="text-xs text-gray-500 mb-1">Precio base:</div>
                                          
                                          {/* ✅ NUEVO: Mostrar AMBAS monedas si el circuito es en USD y paquete en $ */}
                                          {precioUSD > 0 && paquete.moneda === '$' ? (
                                            <div>
                                              {/* Pesos del paquete base */}
                                              <div className="text-lg font-bold text-green-600 mb-1">
                                                $ {Number(precioBasePaquete).toLocaleString('es-AR')}
                                              </div>
                                              {/* Dólares del circuito */}
                                              <div className="text-lg font-bold text-blue-600">
                                                + U$S {Number(precioUSD).toLocaleString('es-AR')}
                                              </div>
                                            </div>
                                          ) : (
                                            <div className={`text-lg font-bold ${monedaCircuito === 'U$S' ? 'text-blue-600' : 'text-green-600'}`}>
                                              {monedaCircuito} {Number(precioAMostrar).toLocaleString('es-AR')}
                                            </div>
                                          )}
                                          
                                          {/* ✅ Impuestos - USAR MONEDA DEL CIRCUITO */}
                                          {impuestosPorPersona > 0 && (
                                            <div className="text-xs text-orange-600 mt-1">
                                              + Impuestos: {monedaCircuito} {impuestosPorPersona.toLocaleString('es-AR')}
                                            </div>
                                          )}
                                          
                                          {/* ✅ Total CON impuestos - AMBAS MONEDAS SI APLICA */}
                                          {precioUSD > 0 && paquete.moneda === '$' ? (
                                            <div className="text-sm font-bold mt-1 pt-1 border-t border-gray-300">
                                              Total: $ {Number(precioBasePaquete + impuestosPorPersona).toLocaleString('es-AR')} + U$S {Number(precioUSD).toLocaleString('es-AR')}
                                            </div>
                                          ) : (
                                            <div className={`text-sm font-bold mt-1 pt-1 border-t ${
                                              monedaCircuito === 'U$S' ? 'text-blue-800 border-blue-300' : 'text-green-800 border-green-300'
                                            }`}>
                                              Total: {monedaCircuito} {totalPorPersona.toLocaleString('es-AR')}
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  
                                  <div className="text-sm text-gray-700 whitespace-pre-line mb-3">
                                    {circuito.descripcion}
                                  </div>
                                  
                                  {/* Tipo de tarifa */}
                                  <div className="text-xs text-gray-500 italic mb-2">
                                    {(() => {
                                      const singlesValue = (paquete.singles || '').toLowerCase().trim();
                                      const esSingle = singlesValue === 'si' || singlesValue === 'sí';
                                      return esSingle 
                                        ? '👤 Tarifa Single' 
                                        : '👥 Tarifa por persona en base doble/triple';
                                    })()}
                                  </div>
                                  
                                  {circuitoSeleccionado?.id === circuito.id && (
                                    <div className="mt-2 flex items-center gap-2">
                                      <div className="text-sm font-semibold text-blue-600">
                                        ✔ Circuito seleccionado
                                      </div>
                                    </div>
                                  )}
                                </div>
                                
                                {/* ✅ BOTÓN DE FINANCIACIÓN - SOLO SI EL CIRCUITO NO ES USD Y PAQUETE NO ES USD */}
                                {(() => {
                                  const esCircuitoUSD = precioUSD > 0;
                                  const esPaqueteUSD = paquete.moneda === 'U$S' || paquete.moneda === 'USD';
                                  
                                  // Si CUALQUIERA es USD, NO mostrar
                                  if (esCircuitoUSD || esPaqueteUSD) {
                                    return null;
                                  }
                                  
                                  return (
                                    <div className="mt-3 pt-3 border-t border-blue-200">
                                      <a 
                                        href="/paginas/medios-de-pago"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-xs hover:underline text-blue-600 hover:text-blue-800 font-medium inline-flex items-center gap-1"
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        ver financiación 💳
                                      </a>
                                    </div>
                                  );
                                })()}
                              </div>
                            );
                          })}
                          </div>

                          {/* Tabla de fechas 
                          <div className="overflow-x-auto">
                            <table className="w-full">
                              <thead className="bg-[#2AA8B0] text-white">
                                <tr>
                                  <th className="px-4 py-3 text-left">Seleccionar</th>
                                  <th className="px-4 py-3 text-left">Fecha de Salida</th>
                                  <th className="px-4 py-3 text-left">Hotel</th>
                                  <th className="px-4 py-3 text-left">Duración</th>
                                  <th className="px-4 py-3 text-left">Transporte</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr className="border-b border-gray-200 hover:bg-gray-50">
                                  <td className="px-4 py-3">
                                    <button 
                                      onClick={() => {
                                        if (!circuitoSeleccionado) {
                                          alert('Selecciona un circuito de arriba');
                                          return;
                                        }
                                        // Solo cerrar el desplegable, no hacer reserva
                                        setCircuitosDesplegado(false);
                                      }}
                                      className={`px-4 py-2 rounded transition-colors ${
                                        circuitoSeleccionado
                                          ? 'bg-blue-600 text-white hover:bg-blue-700'
                                          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                      }`}
                                      disabled={!circuitoSeleccionado}
                                    >
                                      Seleccionar
                                    </button>
                                  </td>
                                  <td className="px-4 py-3">
                                    {paquete.fecha_salida ? 
                                      new Date(paquete.fecha_salida).toLocaleDateString('es-ES', { 
                                        day: '2-digit', 
                                        month: '2-digit', 
                                        year: 'numeric' 
                                      }) 
                                      : 'Fecha flexible'
                                    }
                                    <br />
                                    <span className="text-sm text-gray-500">
                                      {circuitoSeleccionado?.temporada || circuitos[0]?.temporada}
                                    </span>
                                  </td>
                                  <td className="px-4 py-3">{paquete.hotel}</td>
                                  <td className="px-4 py-3">{paquete.duracion}</td>
                                  <td className="px-4 py-3">{paquete.transporte}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>*/}
                        </>
                      )}
                    </div>
                  )}

                  

                </div>

                {/* Panel de reserva */}
                <div className="hidden lg:block lg:w-1/3">
                  <div className="bg-white rounded-2xl shadow-lg p-6 sticky top-24">
                    <h1 className="text-2xl font-bold text-gray-900 mb-4">{paquete.titulo}</h1>
                    
                    <div className="space-y-3 mb-6">
                      <div className="flex items-center gap-2 text-gray-600">
                        <MapPin size={16} />
                        <span>{paquete.destino_nombre}</span>
                      </div>
                      <div className="flex items-center gap-2 text-gray-600">
                        <Calendar size={16} />
                        <span>
                          {paquete.fecha_salida ? 
                            new Date(paquete.fecha_salida).toLocaleDateString('es-ES', { 
                              year: 'numeric', month: 'long', day: 'numeric' 
                            }) : 
                            'Fechas flexibles'
                          }
                        </span>
                      </div>
                      {paquete.disponibilidad && (
                        <div className="flex items-center gap-2 text-gray-600">
                          <Users size={16} />
                          <span>{paquete.disponibilidad} lugares disponibles</span>
                        </div>
                      )}
                      {paquete.hotel && (
                        <div className="flex items-center gap-2 text-gray-600">
                          <Hotel size={16} />
                          <span>{paquete.hotel}</span>
                        </div>
                      )}
                    </div>

                    {/* Precio */}
                    <div className="border-t pt-6">
                      {/*
                      <div className="text-center mb-4">
                        <div className={`text-3xl font-bold ${precioInfo.clase}`}>
                          {formatearPrecio(precioInfo.precio, precioInfo.simbolo)}
                        </div>
                        <div className="text-sm text-gray-500">
                          por persona {precioInfo.moneda === 'USD' ? '(Dólares americanos)' : '(Pesos argentinos)'}
                        </div>
                        <div className="mt-2">
                          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                            precioInfo.moneda === 'USD' 
                              ? 'bg-blue-100 text-blue-800' 
                              : 'bg-green-100 text-green-800'
                          }`}>
                            <DollarSign size={12} className="mr-1" />
                            {precioInfo.moneda === 'USD' ? 'Precio en Dólares' : 'Precio en Pesos'}
                          </span>
                        </div>
                      </div>*/}


                      {!paquete.singles || paquete.singles.toLowerCase() === 'no' ? (
                        <div className="text-xs text-gray-500 mt-2 px-4">
                          ℹ️ Este paquete requiere mínimo 2 pasajeros
                        </div>
                      ) : null}

                      {/* Selector de pasajeros */}
                      <div className="mb-4">
                        {/*
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Número de pasajeros
                        </label>
                        */}
                        <div className="flex items-center justify-between border border-gray-300 rounded-lg p-3">
                          <span className="font-medium">Pasajeros</span>
                          <div className="flex items-center gap-3">
                            <button
                              onClick={() => handlePasajerosChange('decrease')}
                              disabled={reservaData.pasajeros <= pasajerosMinimos}
                              className={`w-8 h-8 rounded-full border-2 flex items-center justify-center ${
                                reservaData.pasajeros <= pasajerosMinimos
                                  ? 'border-gray-200 text-gray-300 cursor-not-allowed' 
                                  : 'border-[#2AA8B0] text-[#2AA8B0] hover:bg-[#2AA8B0] hover:text-white'
                              } transition-colors`}
                            >
                              <Minus size={16} />
                            </button>
                            <span className="text-lg font-semibold text-gray-900 min-w-[2rem] text-center">
                              {reservaData.pasajeros}
                            </span>
                            <button
                              onClick={() => handlePasajerosChange('increase')}
                              disabled={reservaData.pasajeros >= 5}
                              className={`w-8 h-8 rounded-full border-2 flex items-center justify-center ${
                                reservaData.pasajeros >= (paquete.disponibilidad || 8)
                                  ? 'border-gray-200 text-gray-300 cursor-not-allowed' 
                                  : 'border-[#2AA8B0] text-[#2AA8B0] hover:bg-[#2AA8B0] hover:text-white'
                              } transition-colors`}
                            >
                              <Plus size={16} />
                            </button>
                          </div>
                        </div>
                      </div>


                      {/* ✅ Selector de menores - SOLO para paquetes terrestres */}
                      {(() => {
                        const esAereo = paquete.transporte === 'Aéreo' || 
                                        paquete.transporte === 'Aereo' || 
                                        paquete.transporte === 'Avión';
                        
                        // ✅ Si es aéreo, NO mostrar la sección de menores
                        if (esAereo) {
                          return null;
                        }
                        
                        // ✅ Si es terrestre, mostrar selector de menores
                        return (
                          <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Menores (hasta 17 años)
                              {paquete.family_plan_activo && (
                                <span className="ml-2 text-xs text-green-600">
                                  ✓ Family Plan disponible
                                </span>
                              )}
                            </label>
                            
                            <div className="border border-gray-300 rounded-lg p-4">
                              {pasajerosMinimos === 1 ? (
                                <div className="text-center py-4">
                                  <p className="text-sm text-gray-500">
                                    ℹ️ No se pueden cargar menores en paquetes Singles
                                  </p>
                                </div>
                              ) : (
                                <>
                                  <div className="flex items-center justify-between mb-3">
                                    <span className="font-medium">Cantidad de menores</span>
                                    <div className="flex items-center gap-3">
                                      <button
                                        onClick={handleQuitarMenor}
                                        disabled={reservaData.menores.length === 0}
                                        className={`w-8 h-8 rounded-full border-2 flex items-center justify-center ${
                                          reservaData.menores.length === 0
                                            ? 'border-gray-200 text-gray-300 cursor-not-allowed'
                                            : 'border-[#2AA8B0] text-[#2AA8B0] hover:bg-[#2AA8B0] hover:text-white'
                                        } transition-colors`}
                                      >
                                        <Minus size={16} />
                                      </button>
                                      <span className="text-lg font-semibold text-gray-900 min-w-[2rem] text-center">
                                        {reservaData.menores.length}
                                      </span>
                                      <button
                                        onClick={() => {
                                          const disponibilidadTotal = Math.min(paquete?.disponibilidad || 5, 5);
                                          const totalPersonas = reservaData.pasajeros + reservaData.menores.length;
                                          
                                          if (totalPersonas >= disponibilidadTotal) {
                                            alert(`Solo hay ${disponibilidadTotal} lugares disponibles en total`);
                                            return;
                                          }
                                          
                                          if (reservaData.menores.length >= 4) {
                                            alert('Máximo 4 menores permitidos');
                                            return;
                                          }
                                          
                                          setModalEdadVisible(true);
                                        }}
                                        disabled={reservaData.menores.length >= 4}
                                        className={`w-8 h-8 rounded-full border-2 flex items-center justify-center ${
                                          reservaData.menores.length >= 4
                                            ? 'border-gray-200 text-gray-300 cursor-not-allowed'
                                            : 'border-[#2AA8B0] text-[#2AA8B0] hover:bg-[#2AA8B0] hover:text-white'
                                        } transition-colors`}
                                      >
                                        <Plus size={16} />
                                      </button>
                                    </div>
                                  </div>
                                  
                                  <div className="text-xs text-gray-500 mb-2 text-center">
                                    {(() => {
                                      const disponibilidadTotal = Math.min(paquete?.disponibilidad || 5, 5);
                                      const totalPersonas = reservaData.pasajeros + reservaData.menores.length;
                                      const lugaresRestantes = disponibilidadTotal - totalPersonas;
                                      
                                      return lugaresRestantes > 0 
                                        ? `${lugaresRestantes} ${lugaresRestantes === 1 ? 'lugar disponible' : 'lugares disponibles'}`
                                        : 'Sin lugares disponibles';
                                    })()}
                                  </div>
                                  
                                  {/* Lista de menores con edades */}
                                  {reservaData.menores.length > 0 && (
                                    <div className="space-y-2 pt-2 border-t border-gray-200">
                                      {reservaData.menores.map((menor, index) => (
                                        <div key={menor.id} className="flex items-center justify-between bg-gray-50 rounded-lg p-2">
                                          <span className="text-sm text-gray-700">
                                            Menor {index + 1}:
                                          </span>
                                          <div className="flex items-center gap-2">
                                            <input
                                              type="number"
                                              min="0"
                                              max="17"
                                              value={menor.edad}
                                              onChange={(e) => handleCambiarEdadMenor(index, parseInt(e.target.value) || 0)}
                                              className="w-16 border border-gray-300 rounded px-2 py-1 text-center text-sm"
                                            />
                                            <span className="text-sm text-gray-600">años</span>
                                            {paquete.family_plan_activo && 
                                            menor.edad >= 5 && 
                                            menor.edad <= (paquete.family_plan_edad_maxima || 12) && (
                                              <span className="text-xs text-green-600 font-medium">
                                                ✓ Descuento
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                  
                                  {/* Info Family Plan */}
                                  {paquete.family_plan_activo && (
                                    <div className="mt-3 p-2 bg-blue-50 rounded-lg">
                                      <p className="text-xs text-blue-800">
                                        ℹ️ {paquete.family_plan_descripcion || `Menores de 5 a ${paquete.family_plan_edad_maxima || 12} años tienen descuento especial`}
                                      </p>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        );
                      })()}

                      {/* Seguro de viaje (opcional si tiene costo) */}
                      {paquete.tarifa_seguro && parseFloat(paquete.tarifa_seguro) > 0 && (
                      <div className="hidden lg:block mb-4 border border-gray-300 rounded-lg p-4">
                        <label className="flex items-start gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={incluirSeguro}
                            onChange={(e) => setIncluirSeguro(e.target.checked)}
                            className="mt-1 w-5 h-5 text-[#2AA8B0] border-gray-300 rounded focus:ring-[#2AA8B0]"
                          />
                          <div className="flex-1">
                            <div className="font-medium text-gray-900 flex items-center gap-2">
                              {(() => {
                                const tipoSeguro = getTipoSeguro(paquete.transporte);
                                return tipoSeguro.titulo;
                              })()}
                              <a 
                                href="/paginas/informacion-general" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-xs text-[#2AA8B0] hover:text-[#1E3A5F] hover:underline"
                                onClick={(e) => e.stopPropagation()}
                              >
                                Ver condiciones
                              </a>
                            </div>
                            <div className="text-sm text-gray-600 mt-1">
                              {(() => {
                                const tipoSeguro = getTipoSeguro(paquete.transporte);
                                return tipoSeguro.descripcion;
                              })()}
                            </div>
                            <div className="text-sm font-semibold text-[#2AA8B0] mt-2">
                              + {formatearPrecio(parseFloat(paquete.tarifa_seguro), precioInfo.simbolo)} por persona
                            </div>
                            {incluirSeguro && (
                              <div className="text-xs text-gray-500 mt-1">
                                Total: {formatearPrecio(
                                  parseFloat(paquete.tarifa_seguro) * (reservaData.pasajeros + reservaData.menores.length),
                                  precioInfo.simbolo
                                )}
                              </div>
                            )}
                          </div>
                        </label>
                      </div>
                    )}

                      {/* Asistencia COVID (opcional si tiene costo) */}
                      {paquete.tarifa_covid && parseFloat(paquete.tarifa_covid) > 0 && (
                        <div className="hidden lg:block mb-4 border border-gray-300 rounded-lg p-4">
                          <label className="flex items-start gap-3 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={incluirCovid}
                              onChange={(e) => setIncluirCovid(e.target.checked)}
                              className="mt-1 w-5 h-5 text-[#2AA8B0] border-gray-300 rounded focus:ring-[#2AA8B0]"
                            />
                            <div className="flex-1">
                              <div className="font-medium text-gray-900 flex items-center gap-2">
                                Cobertura de Salud
                                <a 
                                  href="/paginas/informacion-general" 
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  className="text-xs text-[#2AA8B0] hover:text-[#1E3A5F] hover:underline"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Ver condiciones
                                </a>
                              </div>
                                <div className="text-sm font-semibold text-[#2AA8B0] mt-2">
                                  + {formatearPrecio(parseFloat(paquete.tarifa_covid), precioInfo.simbolo)} por persona
                                </div>
                                {incluirCovid && (
                                <div className="text-xs text-gray-500 mt-1">
                                  Total: {formatearPrecio(
                                    parseFloat(paquete.tarifa_covid) * (reservaData.pasajeros + reservaData.menores.length),
                                    precioInfo.simbolo
                                  )}
                                </div>
                              )}
                            </div>
                          </label>
                        </div>
                      )}


                      {/* NUEVO: Circuito seleccionado */}
                      {circuitoSeleccionado && (
                        <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <div className="text-sm font-medium text-gray-700 mb-1">
                                Circuito seleccionado:
                              </div>
                              <div className="font-semibold text-gray-900">
                                {circuitoSeleccionado.nombre}
                              </div>
                              {circuitoSeleccionado.precio_usd && circuitoSeleccionado.precio_usd !== '0' && (
                                <div className="text-sm text-blue-600 mt-1">
                                  + U$S {Number(circuitoSeleccionado.precio_usd).toLocaleString('es-AR')} por persona
                                </div>
                              )}
                              {circuitoSeleccionado && impuestos > 0 && (
                                parseFloat(circuitoSeleccionado.precio_usd) > 0 || 
                                parseFloat(circuitoSeleccionado.precio) > 0
                              ) && (
                                <div className="text-xs text-orange-600 mt-1">
                                  + Impuestos: {formatearPrecio(impuestos, '$')}
                                </div>
                              )}
                            </div>
                            <button
                              onClick={() => {
                                setCircuitoSeleccionado(null);
                                setCircuitosDesplegado(true);
                              }}
                              className="text-red-500 hover:text-red-700 ml-2"
                              title="Cambiar circuito"
                            >
                              ✕
                            </button>
                          </div>
                        </div>
                      )}

                      {/* ✅ NUEVO: Tipo de tarifa (Single o Doble/Triple) 
                      <div className="mb-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <p className="text-sm font-medium text-center text-gray-700">
                          {(() => {
                            const singlesValue = (paquete.singles || '').toLowerCase().trim();
                            const esSingle = singlesValue === 'si' || singlesValue === 'sí';
                            return esSingle 
                              ? '👤 Tarifa Single' 
                              : '👥 Tarifa por persona en base doble/triple';
                          })()}
                        </p>
                      </div>
                      */}

                      {/* Total con descuentos */}
                      <div className="bg-gray-50 rounded-lg p-4 mb-6">
                        <div className="space-y-2">
                          {/* ✅ CASO ESPECIAL: MONEDAS MIXTAS */}
                          {precioCalculado.tieneMonedasMixtas ? (
                            <>
                              {/* Precio base por adulto */}
                              <div className="flex justify-between text-xs text-gray-600">
                                <span>Precio base por adulto:</span>
                                <span>
                                  {formatearPrecio(parseFloat(paquete.tarifa || 0), '$')} + U$S {(precioCalculado.montoDolares / (reservaData.pasajeros + reservaData.menores.length)).toLocaleString('es-AR')}
                                </span>
                              </div>

                              {/* Adultos */}
                              <div className="flex justify-between text-sm text-gray-700 font-medium">
                                <span>Adultos ({reservaData.pasajeros}):</span>
                                <span>
                                  {formatearPrecio(parseFloat(paquete.tarifa) * reservaData.pasajeros, '$')} + U$S {((precioCalculado.montoDolares / (reservaData.pasajeros + reservaData.menores.length)) * reservaData.pasajeros).toLocaleString('es-AR')}
                                </span>
                              </div>

                              {/* Menores (si hay) */}
                              {reservaData.menores.length > 0 && (
                                <div className="space-y-1">
                                  <div className="flex justify-between text-xs text-gray-600">
                                    <span>Precio base por menor:</span>
                                    <span>{formatearPrecio(precioCalculado.costoMenores / reservaData.menores.length, '$')} + U$S {(precioCalculado.montoDolares / (reservaData.pasajeros + reservaData.menores.length)).toLocaleString('es-AR')}</span>
                                  </div>
                                  <div className="flex justify-between text-sm text-gray-700 font-medium">
                                    <span>Menores ({reservaData.menores.length}):</span>
                                    <span>
                                      {formatearPrecio(precioCalculado.costoMenores, '$')} + U$S {((precioCalculado.montoDolares / (reservaData.pasajeros + reservaData.menores.length)) * reservaData.menores.length).toLocaleString('es-AR')}
                                    </span>
                                  </div>
                                </div>
                              )}

                              {/* Gastos administrativos (siempre en pesos) */}
                              {precioCalculado.gastosAdministrativos > 0 && (
                                <div className="flex justify-between text-sm text-purple-600">
                                  <span>+ Gastos administrativos:</span>
                                  <span>{formatearPrecio(precioCalculado.gastosAdministrativos, '$')}</span>
                                </div>
                              )}

                              {/* Seguro */}
                              {precioCalculado.costoSeguro > 0 && (
                                <div className="flex justify-between text-sm text-blue-600">
                                  <span>+ Seguro de Cancelación:</span>
                                  <span>{formatearPrecio(precioCalculado.costoSeguro, '$')}</span>
                                </div>
                              )}
                              
                              {/* COVID */}
                              {precioCalculado.costoCovid > 0 && (
                                <div className="flex justify-between text-sm text-purple-600">
                                  <span>+ Cobertura de Salud:</span>
                                  <span>{formatearPrecio(precioCalculado.costoCovid, '$')}</span>
                                </div>
                              )}

                              {/* Total con monedas mixtas */}
                              <div className="flex justify-between items-center pt-2 border-t">
                                <span className="font-medium text-lg">Total:</span>
                                <div className="text-right">
                                  <div className="text-2xl font-bold">
                                    <span className="text-green-600">{formatearPrecio(precioCalculado.montoPesos, '$')}</span>
                                    <span className="text-gray-500 mx-1">+</span>
                                    <span className="text-blue-600">U$S {precioCalculado.montoDolares.toLocaleString('es-AR')}</span>
                                  </div>
                                  <div className="text-xs text-gray-500">
                                    {reservaData.pasajeros + reservaData.menores.length} pasajeros
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {/* ✅ CASO NORMAL: MONEDA ÚNICA (código existente sin cambios) */}
                              {/* Precio base por adulto */}
                              <div className="flex justify-between text-xs text-gray-600">
                                <span>Precio base por adulto:</span>
                                <span>
                                  {circuitoSeleccionado && (precioCalculado.circuitoCosto > 0) ? (
                                    precioCalculado.circuitoMoneda === 'USD'
                                      ? `U$S ${(precioCalculado.circuitoCosto / (reservaData.pasajeros + reservaData.menores.length)).toLocaleString('es-AR')}`
                                      : `$ ${(precioCalculado.circuitoCosto / (reservaData.pasajeros + reservaData.menores.length)).toLocaleString('es-AR')}`
                                  ) : (
                                    formatearPrecio(parseFloat(paquete.tarifa || 0), precioInfo.simbolo)
                                  )}
                                </span>
                              </div>

                              {/* Adultos */}
                              <div className="flex justify-between text-sm text-gray-700 font-medium">
                                <span>Adultos ({reservaData.pasajeros}):</span>
                                <span>
                                  {circuitoSeleccionado && (precioCalculado.circuitoCosto > 0) ? (
                                    precioCalculado.circuitoMoneda === 'USD'
                                      ? `U$S ${precioCalculado.circuitoCosto.toLocaleString('es-AR')}`
                                      : `$ ${precioCalculado.circuitoCosto.toLocaleString('es-AR')}`
                                  ) : (
                                    formatearPrecio(precioCalculado.subtotalOriginal, precioInfo.simbolo)
                                  )}
                                </span>
                              </div>

                              {/* Menores (si hay) */}
                              {reservaData.menores.length > 0 && (
                                <div className="space-y-1">
                                  <div className="flex justify-between text-xs text-gray-600">
                                    <span>Precio base por menor:</span>
                                    <span>{formatearPrecio(precioCalculado.costoMenores / reservaData.menores.length, precioInfo.simbolo)}</span>
                                  </div>
                                  <div className="flex justify-between text-sm text-gray-700 font-medium">
                                    <span>Menores ({reservaData.menores.length}):</span>
                                    <span>{formatearPrecio(precioCalculado.costoMenores, precioInfo.simbolo)}</span>
                                  </div>
                                </div>
                              )}
                              
                              {/* Descuentos */}
                              {precioCalculado.detalles && precioCalculado.detalles.length > 0 && 
                              !(circuitoSeleccionado && precioCalculado.circuitoMoneda === 'USD') && (
                                <>
                                  {precioCalculado.detalles.map((desc, index) => (
                                    <div key={index} className="flex justify-between text-sm text-green-600">
                                      <span>✓ {desc.descripcion}{desc.edades && ` (${desc.edades} años)`}:</span>
                                      <span>-{formatearPrecio(desc.monto, precioInfo.simbolo)}</span>
                                    </div>
                                  ))}
                                </>
                              )}

                              {/* Impuestos */}
                              {precioCalculado.impuestos > 0 && (
                                <div className="flex justify-between text-sm text-orange-600">
                                  <span>+ Impuestos:</span>
                                  <span>
                                    {/* ✅ Usar moneda del circuito o del paquete */}
                                    {precioCalculado.circuitoMoneda === 'USD'
                                      ? `U$S ${Number(precioCalculado.impuestos).toLocaleString('es-AR')}`
                                      : formatearPrecio(precioCalculado.impuestos, precioInfo.simbolo)
                                    }
                                  </span>
                                </div>
                              )}

                              {/* Gastos administrativos */}
                              {precioCalculado.gastosAdministrativos > 0 && (
                                <div className="flex justify-between text-sm text-purple-600">
                                  <span>+ Gastos administrativos:</span>
                                  <span>
                                    {/* ✅ Usar moneda del circuito o del paquete */}
                                    {precioCalculado.circuitoMoneda === 'USD'
                                      ? `U$S ${Number(precioCalculado.gastosAdministrativos).toLocaleString('es-AR')}`
                                      : formatearPrecio(precioCalculado.gastosAdministrativos, precioInfo.simbolo)
                                    }
                                  </span>
                                </div>
                              )}

                              {/* Seguro */}
                              {precioCalculado.costoSeguro > 0 && (
                                <div className="flex justify-between text-sm text-blue-600">
                                  <span>+ Seguro de Cancelación:</span>
                                  <span>{formatearPrecio(precioCalculado.costoSeguro, precioInfo.simbolo)}</span>
                                </div>
                              )}
                              
                              {/* COVID */}
                              {precioCalculado.costoCovid > 0 && (
                                <div className="flex justify-between text-sm text-purple-600">
                                  <span>+ Cobertura de Salud:</span>
                                  <span>{formatearPrecio(precioCalculado.costoCovid, precioInfo.simbolo)}</span>
                                </div>
                              )}
                            
                              {/* Total final */}
                              <div className="flex justify-between items-center pt-2 border-t">
                                <span className="font-medium text-lg">Total:</span>
                                <div className="text-right">
                                  {precioCalculado.precioTotal > 0 ? (
                                    <>
                                      {circuitoSeleccionado && precioCalculado.circuitoMoneda === 'USD' ? (
                                        <span className="text-2xl font-bold text-blue-600">
                                          U$S {precioCalculado.precioTotal.toLocaleString('es-AR', {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                          })}
                                        </span>
                                      ) : (
                                        <span className={`text-2xl font-bold ${precioInfo.clase}`}>
                                          {formatearPrecio(precioCalculado.precioTotal, precioInfo.simbolo)}
                                        </span>
                                      )}
                                      <div className="text-xs text-gray-500">
                                        {reservaData.pasajeros + reservaData.menores.length} pasajeros
                                      </div>
                                    </>
                                  ) : (
                                    <span className="text-gray-500">Consultar</span>
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>


                      {/* Botones */}
                      <div className="space-y-3">
                        <button
                          onClick={handleReserva}
                          disabled={reservando || !circuitoSeleccionado}
                          className="w-full bg-[#2AA8B0] text-white py-4 rounded-xl font-semibold text-lg hover:bg-[#1E3A5F] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          {reservando ? 'Procesando reserva...' : 'Comprar ahora'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contenido principal */}
          <div className="container mx-auto px-4 py-8">
            <div className="lg:w-2/3">

              {/* ✅ NUEVO: Descripción de vuelos mejorada */}
              {(() => {
                const esAereo = paquete.transporte === 'Aéreo' || 
                                paquete.transporte === 'Aereo' || 
                                paquete.transporte === 'Avión';
                
                if (!esAereo || !paquete.descripcion_viaje) {
                  return null;
                }
                
                // Parsear los tramos de vuelo
                const parseVuelos = (texto) => {
                  const bloques = texto.split('<br><br>');
                  const tramos = [];
                  let notasFinales = '';
                  
                  bloques.forEach(bloque => {
                    if (bloque.includes('Los vuelos pueden')) {
                      notasFinales = bloque.replace(/<[^>]*>/g, '');
                      return;
                    }
                    
                    const lineas = bloque.split('<br>');
                    const datos = {};
                    
                    lineas.forEach(linea => {
                      const match = linea.match(/<b>(.*?)<\/b>:\s*(.*)/);
                      if (match) {
                        const campo = match[1].trim();
                        const valor = match[2].trim();
                        datos[campo] = valor;
                      }
                    });
                    
                    if (datos.Tramo) {
                      tramos.push(datos);
                    }
                  });
                  
                  return { tramos, notasFinales };
                };
                
                const { tramos, notasFinales } = parseVuelos(paquete.descripcion_viaje);
                
                // Función para formatear los códigos de aeropuerto
                const formatearTramo = (codigo) => {
                  const aeropuertos = {
                    'AEP': 'Buenos Aires (Aeroparque)',
                    'EZE': 'Buenos Aires (Ezeiza)',
                    'USH': 'Ushuaia',
                    'FTE': 'El Calafate',
                    'BRC': 'Bariloche',
                    'COR': 'Córdoba',
                    'MDZ': 'Mendoza',
                    'IGR': 'Iguazú',
                    'SLA': 'Salta',
                    'TUC': 'Tucumán',
                    'RGL': 'Río Gallegos'
                  };
                  
                  if (codigo.length === 6) {
                    const origen = codigo.substring(0, 3);
                    const destino = codigo.substring(3, 6);
                    return `${aeropuertos[origen] || origen} → ${aeropuertos[destino] || destino}`;
                  }
                  
                  return codigo;
                };
                
                return (
                  <section className="bg-white rounded-2xl shadow-lg p-8 mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                      <Plane size={28} className="text-[#2AA8B0]" />
                      Información de Vuelos
                    </h2>
                    
                    {/* Grid de tramos */}
                    <div className="space-y-4 mb-6">
                      {tramos.map((tramo, index) => (
                        <div key={index} className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl p-6 hover:shadow-lg transition-all">
                          {/* Header del tramo */}
                          <div className="flex items-center gap-3 mb-4 pb-3 border-b border-blue-200">
                            <span className="bg-[#2AA8B0] text-white px-4 py-1.5 rounded-full text-sm font-bold">
                              Tramo {index + 1}
                            </span>
                            <span className="text-xl font-bold text-gray-900">
                              {formatearTramo(tramo.Tramo)}
                            </span>
                          </div>
                          
                          {/* Información del vuelo en grid */}
                          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                            {/* Fecha */}
                            <div className="bg-white rounded-lg p-3 shadow-sm">
                              <div className="flex items-center gap-2 text-gray-600 text-xs mb-1">
                                <Calendar size={14} />
                                <span>Fecha</span>
                              </div>
                              <div className="font-bold text-gray-900">{tramo.Fecha}</div>
                            </div>
                            
                            {/* Número de vuelo */}
                            <div className="bg-white rounded-lg p-3 shadow-sm">
                              <div className="flex items-center gap-2 text-gray-600 text-xs mb-1">
                                <Plane size={14} />
                                <span>Vuelo</span>
                              </div>
                              <div className="font-bold text-blue-600">{tramo.Vuelo}</div>
                            </div>
                            
                            {/* Salida */}
                            <div className="bg-white rounded-lg p-3 shadow-sm">
                              <div className="flex items-center gap-2 text-gray-600 text-xs mb-1">
                                <Clock size={14} />
                                <span>Salida</span>
                              </div>
                              <div className="font-bold text-gray-900">{tramo.Salida} hs</div>
                            </div>
                            
                            {/* Arribo */}
                            <div className="bg-white rounded-lg p-3 shadow-sm">
                              <div className="flex items-center gap-2 text-gray-600 text-xs mb-1">
                                <Clock size={14} />
                                <span>Arribo</span>
                              </div>
                              <div className="font-bold text-green-600">{tramo.Arribo} hs</div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    {/* Notas importantes */}
                    {notasFinales && (
                      <div className="bg-yellow-50 border-l-4 border-yellow-400 rounded-lg p-5">
                        <div className="flex gap-3">
                          <span className="text-2xl flex-shrink-0">⚠️</span>
                          <div className="flex-1">
                            <p className="text-sm font-bold text-yellow-900 mb-2">Información Importante</p>
                            <p className="text-sm text-yellow-800 leading-relaxed">
                              {notasFinales}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {/* Info adicional sobre equipaje (si existe) */}
                    {notasFinales.includes('equipaje') && (
                      <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-4">
                        <p className="text-sm text-blue-800 flex items-start gap-2">
                          {/*<span className="text-lg">🧳</span>
                          <span>
                            <strong>Equipaje permitido:</strong> Los límites de equipaje varían según la aerolínea. 
                            Consulta las condiciones específicas de tu vuelo.
                          </span>*/}
                        </p>
                      </div>
                    )}
                  </section>
                );
              })()}

              
              {/* Descripción del paquete */}
              <section className="bg-white rounded-2xl shadow-lg p-8 mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Descripción del paquete</h2>
                <div className="prose prose-gray max-w-none">
                  {paquete.descripcion ? (
                    <div
                      dangerouslySetInnerHTML={{ 
                        __html: showFullDescription ? paquete.descripcion : paquete.descripcion.substring(0, 300) + '...' 
                      }}
                    />
                  ) : (
                    <p className="text-gray-600">
                      Disfruta de una experiencia única en {paquete.destino_nombre} con este increíble paquete de {paquete.duracion}. 
                      Incluye todo lo necesario para que tengas unas vacaciones inolvidables con la mejor atención y servicios.
                    </p>
                  )}
                  {paquete.descripcion && paquete.descripcion.length > 300 && (
                    <button
                      onClick={() => setShowFullDescription(!showFullDescription)}
                      className="text-[#2AA8B0] hover:text-[#1E3A5F] font-medium mt-4"
                    >
                      {showFullDescription ? 'Ver menos' : 'Ver más'}
                    </button>
                  )}
                </div>
              </section>

              {/* Preguntas frecuentes */}
              <section className="mb-12">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Preguntas frecuentes (FAQ)
                </h2>
                
                {loadingFAQ ? (
                  <div className="text-center py-8 text-gray-500">
                    Cargando preguntas frecuentes...
                  </div>
                ) : faqPaquetes.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">
                    No hay preguntas frecuentes disponibles.
                  </div>
                ) : (
                  <div className="space-y-4">
                    {faqPaquetes.map((faq, index) => (
                      <div key={faq.id} className="border border-gray-200 rounded-xl overflow-hidden">
                        <button
                          onClick={() => toggleFAQ(index)}
                          className="w-full p-4 text-left font-medium text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between"
                        >
                          <span>{faq.pregunta}</span>
                          {showFAQ[index] ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                        </button>
                        {showFAQ[index] && (
                          <div className="px-4 pb-4 text-gray-600 border-t border-gray-200 bg-gray-50">
                            <div 
                              className="pt-4 whitespace-pre-line"
                              dangerouslySetInnerHTML={{ __html: faq.respuesta }}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </section>
            </div>
          </div>
        </div>
        
        <Footer />

        {/* ✅ Botón WhatsApp - Solo visible en DESKTOP (el de mobile está en ModalPrecioMobile) */}
        <div className="hidden lg:block">
          <WhatsAppButton />
        </div> 
        
        {/* ✅ AGREGAR ESTO: Modal fijo mobile */}
        <ModalPrecioMobile
          visible={!isMenuOpen} 
          precioCalculado={precioCalculado}
          precioInfo={precioInfo}
          reservaData={reservaData}
          formatearPrecio={formatearPrecio}
          onReservar={handleReserva}
          circuitoSeleccionado={circuitoSeleccionado}
          paquete={paquete}
          incluirSeguro={incluirSeguro}
          setIncluirSeguro={setIncluirSeguro}
          incluirCovid={incluirCovid}
          setIncluirCovid={setIncluirCovid}
          handlePasajerosChange={handlePasajerosChange}
          pasajerosMinimos={pasajerosMinimos}
          setModalEdadVisible={setModalEdadVisible}
          handleQuitarMenor={handleQuitarMenor}
        />

        {/* ✅ Modal para seleccionar edad */}
        <ModalEdadMenor
          visible={modalEdadVisible}
          onClose={() => setModalEdadVisible(false)}
          onConfirm={handleAgregarMenor}
        />

        {/* Formulario oculto de redirección */}
        {sessionData && (
          <ReservaRedirect 
            sessionData={sessionData}
            onComplete={() => console.log('Redirigiendo a reservas...')}
          />
        )}
      </div>
    </>
  );
}

// ✅ AGREGAR ANTES DEL EXPORT
// Componente de modal fijo mobile
// ✅ COMPONENTE MODAL MOBILE MEJORADO CON SELECTOR DE PASAJEROS Y COLAPSABLE
const ModalPrecioMobile = ({ 
  visible, 
  precioCalculado, 
  precioInfo, 
  reservaData, 
  formatearPrecio, 
  onReservar, 
  circuitoSeleccionado, 
  paquete,
  incluirSeguro, 
  setIncluirSeguro, 
  incluirCovid, 
  setIncluirCovid,
  // ✅ NUEVO: Props necesarias para manejar pasajeros
  handlePasajerosChange,
  pasajerosMinimos,
  setModalEdadVisible,
  handleQuitarMenor
}) => {
  const [collapsed, setCollapsed] = React.useState(true); // Estado para colapsar/expandir
  
  if (!visible) return null;

  return (
    <>
      {/* ✅ Botones flotantes - Se ocultan cuando el modal está expandido */}
      {collapsed && (
      <div className="lg:hidden fixed right-4 bottom-36 flex flex-col gap-3 z-50">
        {/* Botón Scroll to Top */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="w-12 h-12 bg-[#2AA8B0] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#1E3A5F] transition-colors"
          title="Volver arriba"
        >
          <ChevronUp size={24} />
        </button>
        
        {/*  Botón WhatsApp  */}
        <a
          href="https://wa.me/5491168455601?text=Hola%2C%20necesito%20info%20sobre%E2%80%A6%0APara%20poder%20responderte%2C%20indic%C3%A1%20destino%2C%20fecha%20y%20cantidad%20de%20pasajeros"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#20BA5A] transition-colors"
          title="WhatsApp"
        >
          <svg viewBox="0 0 32 32" className="w-8 h-8" fill="white">
            <path d="M16 0C7.164 0 0 7.163 0 16c0 2.816.736 5.464 2.014 7.76L.064 30.667a.667.667 0 0 0 .827.827l6.907-1.95A15.936 15.936 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333A13.277 13.277 0 0 1 8.333 27.2a.667.667 0 0 0-.546-.067l-5.134 1.45 1.45-5.133a.667.667 0 0 0-.067-.547A13.277 13.277 0 0 1 2.667 16c0-7.364 5.97-13.333 13.333-13.333S29.333 8.636 29.333 16 23.364 29.333 16 29.333z"/>
            <path d="M23.573 19.44c-.36-.18-2.127-1.047-2.457-1.167-.33-.12-.57-.18-.81.18-.24.36-.93 1.167-1.14 1.407-.21.24-.42.27-.78.09-.36-.18-1.52-.56-2.897-1.787-1.07-.954-1.793-2.133-2.003-2.493-.21-.36-.023-.554.157-.733.161-.161.36-.42.54-.63.18-.21.24-.36.36-.6.12-.24.06-.45-.03-.63-.09-.18-.81-1.95-1.11-2.67-.293-.7-.59-.605-.81-.617-.21-.01-.45-.013-.69-.013s-.63.09-.96.45c-.33.36-1.26 1.23-1.26 3s1.29 3.48 1.47 3.72c.18.24 2.54 3.88 6.157 5.443.86.373 1.533.596 2.057.763.863.274 1.65.236 2.273.143.693-.103 2.127-.87 2.427-1.71.3-.84.3-1.56.21-1.71-.09-.15-.33-.24-.69-.42z"/>
          </svg>
        </a> 
        


      </div>
      )}
      <div className={`fixed bottom-0 left-0 right-0 bg-white border-t-2 border-[#2AA8B0] shadow-2xl z-40 overflow-hidden lg:hidden transition-all duration-300 w-full ${
        collapsed ? 'max-h-32' : 'max-h-[85vh]'
      }`}>
      {/* ✅ Header con flecha para colapsar */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="w-full bg-[#2AA8B0] text-white py-2 px-4 flex items-center justify-between hover:bg-[#1E3A5F] transition-colors"
      >
        <span className="font-semibold text-sm">
          {collapsed ? '▲ Ver detalles' : '▼ Ocultar'}
        </span>
        <div className="flex items-center gap-2">
          {collapsed && precioCalculado.tieneMonedasMixtas ? (
            <span className="text-xs font-bold">
              $ {precioCalculado.montoPesos.toLocaleString('es-AR')} + U$S {precioCalculado.montoDolares.toLocaleString('es-AR')}
            </span>
          ) : collapsed ? (
            <span className="text-xs font-bold">
              {precioCalculado.circuitoMoneda === 'USD' 
                ? `U$S ${precioCalculado.precioTotal.toLocaleString('es-AR')}` 
                : formatearPrecio(precioCalculado.precioTotal, precioInfo.simbolo)
              }
            </span>
          ) : null}
        </div>
      </button>
      
      {/* ✅ NUEVO: Botón de compra cuando está colapsado */}
      {collapsed && (
        <div className="p-3">
          <button
            onClick={onReservar}
            disabled={!circuitoSeleccionado}
            className="w-full bg-[#2AA8B0] text-white py-3 rounded-xl font-bold text-base hover:bg-[#1E3A5F] transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
          >
            {circuitoSeleccionado ? 'Comprar ahora' : 'Selecciona un circuito'}
          </button>
        </div>
      )}

      {/* ✅ Contenido colapsable */}
      {!collapsed && (
        <div className="overflow-y-auto w-full" style={{ maxHeight: 'calc(85vh - 52px)' }}>
          <div className="p-4 w-full">
            {/* ✅ NUEVO: Selector de pasajeros adultos */}
            <div className="mb-3 bg-gray-50 rounded-xl p-3 border-2 border-gray-200">
              <div className="flex items-center justify-between mb-2">
                <span className="font-bold text-sm text-gray-900">Pasajeros adultos</span>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handlePasajerosChange('decrease')}
                    disabled={reservaData.pasajeros <= pasajerosMinimos}
                    className={`w-8 h-8 rounded-full border-2 flex items-center justify-center text-lg ${
                      reservaData.pasajeros <= pasajerosMinimos
                        ? 'border-gray-200 text-gray-300 cursor-not-allowed' 
                        : 'border-[#2AA8B0] text-[#2AA8B0] hover:bg-[#2AA8B0] hover:text-white'
                    } transition-colors`}
                  >
                    −
                  </button>
                  <span className="text-xl font-bold text-gray-900 min-w-[2.5rem] text-center">
                    {reservaData.pasajeros}
                  </span>
                  <button
                    onClick={() => handlePasajerosChange('increase')}
                    disabled={reservaData.pasajeros >= 5}
                    className={`w-8 h-8 rounded-full border-2 flex items-center justify-center text-lg ${
                      reservaData.pasajeros >= 5
                        ? 'border-gray-200 text-gray-300 cursor-not-allowed' 
                        : 'border-[#2AA8B0] text-[#2AA8B0] hover:bg-[#2AA8B0] hover:text-white'
                    } transition-colors`}
                  >
                    +
                  </button>
                </div>
              </div>
              
              {!paquete.singles || paquete.singles.toLowerCase() === 'no' ? (
                <div className="text-xs text-gray-500 text-center py-1 bg-blue-50 rounded">
                  ℹ️ Este paquete requiere mínimo 2 pasajeros
                </div>
              ) : null}
            </div>

            {/* ✅ NUEVO: Selector de menores - SOLO si NO es aéreo Y NO es singles */}
            {(() => {
              const esAereo = paquete.transporte === 'Aéreo' || 
                              paquete.transporte === 'Aereo' || 
                              paquete.transporte === 'Avión';
              
              if (esAereo || pasajerosMinimos === 1) {
                return null;
              }
              
              return (
                <div className="mb-3 bg-gray-50 rounded-xl p-3 border-2 border-gray-200">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-bold text-sm text-gray-900">
                      Menores (hasta 17 años)
                      {paquete.family_plan_activo && (
                        <span className="ml-1 text-xs text-green-600 font-semibold">✓ Plan familiar</span>
                      )}
                    </span>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={handleQuitarMenor}
                        disabled={reservaData.menores.length === 0}
                        className={`w-8 h-8 rounded-full border-2 flex items-center justify-center text-lg ${
                          reservaData.menores.length === 0
                            ? 'border-gray-200 text-gray-300 cursor-not-allowed'
                            : 'border-[#2AA8B0] text-[#2AA8B0] hover:bg-[#2AA8B0] hover:text-white'
                        } transition-colors`}
                      >
                        −
                      </button>
                      <span className="text-xl font-bold text-gray-900 min-w-[2.5rem] text-center">
                        {reservaData.menores.length}
                      </span>
                      <button
                        onClick={() => {
                          const disponibilidadTotal = Math.min(paquete?.disponibilidad || 5, 5);
                          const totalPersonas = reservaData.pasajeros + reservaData.menores.length;
                          
                          if (totalPersonas >= disponibilidadTotal) {
                            alert(`Solo hay ${disponibilidadTotal} lugares disponibles en total`);
                            return;
                          }
                          
                          if (reservaData.menores.length >= 4) {
                            alert('Máximo 4 menores permitidos');
                            return;
                          }
                          
                          setModalEdadVisible(true);
                        }}
                        disabled={reservaData.menores.length >= 4}
                        className={`w-8 h-8 rounded-full border-2 flex items-center justify-center text-lg ${
                          reservaData.menores.length >= 4
                            ? 'border-gray-200 text-gray-300 cursor-not-allowed'
                            : 'border-[#2AA8B0] text-[#2AA8B0] hover:bg-[#2AA8B0] hover:text-white'
                        } transition-colors`}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  
                  {/* Lista de menores con edades */}
                  {reservaData.menores.length > 0 && (
                    <div className="space-y-1 mt-2">
                      {reservaData.menores.map((menor, index) => (
                        <div key={menor.id} className="flex items-center justify-between bg-white rounded-lg p-2 border border-gray-300">
                          <span className="text-sm text-gray-700">Menor {index + 1}:</span>
                          <span className="font-bold text-gray-900">{menor.edad} años</span>
                        </div>
                      ))}
                    </div>
                  )}
                  
                  <div className="text-xs text-gray-500 mt-2 text-center bg-blue-50 py-1 rounded">
                    {(() => {
                      const disponibilidadTotal = Math.min(paquete?.disponibilidad || 5, 5);
                      const totalPersonas = reservaData.pasajeros + reservaData.menores.length;
                      const lugaresRestantes = disponibilidadTotal - totalPersonas;
                      
                      return lugaresRestantes > 0 
                        ? `${lugaresRestantes} ${lugaresRestantes === 1 ? 'lugar disponible' : 'lugares disponibles'}`
                        : 'Sin lugares disponibles';
                    })()}
                  </div>
                </div>
              );
            })()}

            {/* ✅ Extras opcionales (Seguro y COVID) */}
            <div className="mb-3 space-y-2">
              <div className="grid grid-cols-2 gap-2">
                {/* Seguro de viaje */}
                {paquete?.tarifa_seguro && parseFloat(paquete.tarifa_seguro) > 0 && (
                  <label className="flex items-start gap-1.5 p-2 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#2AA8B0] transition-colors bg-white">
                    <input
                      type="checkbox"
                      checked={incluirSeguro}
                      onChange={(e) => setIncluirSeguro(e.target.checked)}
                      className="mt-0.5 w-4 h-4 text-[#2AA8B0] border-gray-300 rounded focus:ring-[#2AA8B0]"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="font-semibold text-gray-900 text-xs leading-tight">
                        Seg. Cancelación
                      </div>
                      <div className="text-xs font-bold text-[#2AA8B0] mt-0.5">
                        +{formatearPrecio(parseFloat(paquete.tarifa_seguro), precioInfo.simbolo)}
                      </div>
                    </div>
                  </label>
                )}

                {/* Asistencia COVID */}
                {paquete?.tarifa_covid && parseFloat(paquete.tarifa_covid) > 0 && (
                  <label className="flex items-start gap-1.5 p-2 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#2AA8B0] transition-colors bg-white">
                    <input
                      type="checkbox"
                      checked={incluirCovid}
                      onChange={(e) => setIncluirCovid(e.target.checked)}
                      className="mt-0.5 w-4 h-4 text-[#2AA8B0] border-gray-300 rounded focus:ring-[#2AA8B0]"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="font-semibold text-gray-900 text-xs leading-tight">
                        Cob. Salud
                      </div>
                      <div className="text-xs font-bold text-[#2AA8B0] mt-0.5">
                        +{formatearPrecio(parseFloat(paquete.tarifa_covid), precioInfo.simbolo)}
                      </div>
                    </div>
                  </label>
                )}
              </div>
            </div>

            {/* Desglose de precio */}
            <div className="mb-3 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-3 border border-gray-200">
              <div className="flex justify-between items-center mb-2">
                <span className="text-xs text-gray-600 font-medium">
                  Total pasajeros: {reservaData.pasajeros + (reservaData.menores?.length || 0)}
                </span>
                {precioCalculado.descuentoTotal > 0 && (
                  <span className="text-xs text-green-600 font-bold">
                    ✓ Con descuentos
                  </span>
                )}
              </div>
              
              {/* Circuito seleccionado */}
              {circuitoSeleccionado && (
                <div className="text-xs text-blue-700 mb-2 font-semibold bg-blue-50 p-2 rounded">
                  📋 {circuitoSeleccionado.nombre}
                </div>
              )}

              {/* Costos adicionales */}
              {(precioCalculado.costoSeguro > 0 || precioCalculado.costoCovid > 0) && (
                <div className="space-y-1 mb-2 pb-2 border-b border-gray-300">
                  {precioCalculado.costoSeguro > 0 && (
                    <div className="flex justify-between text-xs">
                      <span className="text-gray-600">Seg. Cancelación:</span>
                      <span className="text-blue-600 font-semibold">
                        +{formatearPrecio(precioCalculado.costoSeguro, precioInfo.simbolo)}
                      </span>
                    </div>
                  )}
                  {precioCalculado.costoCovid > 0 && (
                    <div className="flex justify-between text-xs">
                      <span className="text-gray-600">Cob. Salud:</span>
                      <span className="text-purple-600 font-semibold">
                        +{formatearPrecio(precioCalculado.costoCovid, precioInfo.simbolo)}
                      </span>
                    </div>
                  )}
                </div>
              )}
              
              {/* Desglose adicional */}
              {precioCalculado.impuestos > 0 && (
                <div className="flex justify-between text-xs">
                  <span className="text-gray-600">+ Impuestos:</span>
                  <span className="text-orange-600 font-semibold">
                    {precioCalculado.circuitoMoneda === 'USD'
                      ? `U$S ${Number(precioCalculado.impuestos).toLocaleString('es-AR')}`
                      : formatearPrecio(precioCalculado.impuestos, precioInfo.simbolo)
                    }
                  </span>
                </div>
              )}
              
              {precioCalculado.gastosAdministrativos > 0 && (
                <div className="flex justify-between text-xs">
                  <span className="text-gray-600">+ Gastos administrativos:</span>
                  <span className="text-purple-600 font-semibold">
                    {precioCalculado.circuitoMoneda === 'USD'
                      ? `U$S ${Number(precioCalculado.gastosAdministrativos).toLocaleString('es-AR')}`
                      : formatearPrecio(precioCalculado.gastosAdministrativos, precioInfo.simbolo)
                    }
                  </span>
                </div>
              )}
              
              {/* Precio total */}
              <div className="flex justify-between items-center pt-2 border-t-2 border-gray-300">
                <span className="text-base font-bold text-gray-900">Total:</span>
                <div className="text-right">
                  {precioCalculado.tieneMonedasMixtas ? (
                    <div className="text-lg font-bold">
                      <div className="text-green-600">{formatearPrecio(precioCalculado.montoPesos, '$')}</div>
                      <div className="text-blue-600">+ U$S {precioCalculado.montoDolares.toLocaleString('es-AR')}</div>
                    </div>
                  ) : precioCalculado.circuitoMoneda === 'USD' ? (
                    <span className="text-2xl font-bold text-blue-600">
                      U$S {precioCalculado.precioTotal.toLocaleString('es-AR', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })}
                    </span>
                  ) : (
                    <span className={`text-2xl font-bold ${precioInfo.clase}`}>
                      {formatearPrecio(precioCalculado.precioTotal, precioInfo.simbolo)}
                    </span>
                  )}
                  <div className="text-xs text-gray-500 mt-0.5">
                    {reservaData.pasajeros + (reservaData.menores?.length || 0)} pasajeros
                  </div>
                </div>
              </div>
            </div>

            {/* Botón de reserva */}
            <button
              onClick={onReservar}
              disabled={!circuitoSeleccionado}
              className="w-full bg-[#2AA8B0] text-white py-4 rounded-xl font-bold text-lg hover:bg-[#1E3A5F] transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
            >
              {circuitoSeleccionado ? 'Comprar ahora' : 'Selecciona un circuito'}
            </button>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default PaqueteDetail;